/* eslint-disable no-undef */
/* eslint-disable no-mixed-operators */
import popupCloseIcon from "../../assests/page/popup-close-icon.svg";
import backIcon from "../../assests/page/chevron-left.svg";
import alarmIcon from "../../assests/sideBar/alarm.svg";
import favoriteIcon from "../../assests/overlay/Star.svg";
import favoriteClickedIcon from "../../assests/overlay/star-clicked.svg";
import productLogo from "../../assests/page/product-logo.svg";
import graphIcon from "../../assests/page/graph-image.svg";
import graphNumbersIcon from "../../assests/page/graph-numbers-image.svg";
import increaseIcon from "../../assests/page/add.svg";
import decreaseIcon from "../../assests/page/remove.svg";
import infoIcon from "../../assests/page/info-icon.svg";
import radioButtonIcon from "../../assests/page/radio-button.svg";
import radioButtonClickedIcon from "../../assests/page/radio-button-clicked.svg";
import walletIcon from "../../assests/page/wallet-icon.svg";
import priceUp from "../../assests/page/asset-price-up-icon.svg";
import priceDown from "../../assests/page/asset-price-up-icon.svg";
import collateralBank from "../../assests/page/collateral-bank-icon.svg";
import collateralBankInactive from "../../assests/page/collateral-bank-icon-inactive.svg";
import exandIcon from "../../assests/page/chevron-right.svg";
import maximizeIcon from "../../assests/overlay/maximize-icon.svg";
import minimizeIcon from "../../assests/overlay/minimize-icon.svg";
import bankAccountIcon from "../../assests/page/bank-account-icon.svg";
import collateralExpand from "../../assests/page/asset-collateral-right.svg";
import expandMoreIcon from "../../assests/page/expand-more-blue.svg";
import defaultExpandMoreIcon from "../../assests/page/expand-more-icon.svg";
import typeIcon from "../../assests/overlay/type-icon.svg";
import volumeIcon from "../../assests/overlay/volume-icon.svg";
import calenderIcon from "../../assests/overlay/calender-icon.svg";
import categoryIcon from "../../assests/overlay/category-icon.svg";
import athIcon from "../../assests/overlay/ath-icon.svg";
import atlIcon from "../../assests/overlay/atl-icon.svg";
import fixedFeeIcon from "../../assests/overlay/trade-fee-icon.svg";
import priceIndIcon from "../../assests/overlay/price-ind-icon.svg";
import priceDotIcon from "../../assests/overlay/price-dot-icon.svg";
import bulbIcon from "../../assests/overlay/red-bulb-icon.svg";
import calenderBgIcon from "../../assests/overlay/calender-bg-icon.svg";
import netDividendIcon from "../../assests/overlay/net-dividend-icon.svg";
import dividendYieldIcon from "../../assests/overlay/dividend-yield-icon.svg";
import payoutIcon from "../../assests/overlay/payout-icon.svg";
import expandForwardIcon from "../../assests/overlay/forward-expand-icon.svg";
import candleStickIcon from "../../assests/overlay/candle-stick-icon.svg";
import lineChartIcon from "../../assests/overlay/line-chart-icon.svg";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import AddFunds from "./addFunds";
import PageSeperator from "../overlays/pageSeperator";
import Avatar from "react-avatar";
import { toast } from "react-toastify";
import {
  createPrimaryOrder,
  createSecondaryAndMarginOrder,
} from "../../services/contracts/vaultContract";
import { ethers } from "ethers";
import {
  currenciesToFiat,
  currenciesToSymbol,
  errorToast,
  PoolType,
  sponsorTxUrl,
  successToast,
  tokenGcexAlias,
} from "../../utils/constants";
import ERC20ABI from "../../utils/abis/ERC20.json";
import MARGINMANAGERABI from "../../utils/abis/marginManager.json";
import { contractAddress } from "@verified-network/verified-sdk";
import { useAppKit } from "@reown/appkit/react";
import expandIcon from "../../assests/page/portfolio-expand.svg";
import { getTokensSwapRate, swapTokenWithParaSwap } from "../../lib/paraswap";
import { ChainConfig, chainDetails } from "../../utils/config";
import { AreaChart, CandleStickChart } from "../overlays/charts";
import useNetworkStore from "../../store/networkStore";
import useUserStore from "../../store/userSlice";
import {
  offerCollateral,
  withdrawCollateral,
} from "../../services/contracts/issueAndSecurityManager";
import {
  getUserCustodyBanks,
  setUserCustodyBanks,
} from "../../services/contracts/clientContract";
import {
  blinkActiveBanks,
  blinkCustodyAccounts,
} from "../../utils/helpers/blink";
import {
  calculateMaxFastTransferAndProtocolFee,
  calculatePrimaryAndSecondarySOR,
  capitalizeFirstLetter,
  fetchTokenPriceCoinbase,
  fetchTokenPriceCoingecko,
  fetchTokenPriceFromVerified,
  formatNumberAsPrice,
  formatNumberWithUnits,
  getAllVerifiedCashBalances,
  getAndCalculateLiveFeesHyper,
} from "../../utils/helpers/utils";
import { authenticateKYCStatus } from "../../utils/helpers/kyc";
import {
  createNewCustomer,
  createOrder,
  fetchCustomerDetails,
  fetchTickeChartData,
} from "../../utils/helpers/gtn";
import GeneralPopupBackground from ".";
import PaymentProcess from "./paymentProcess";
import SuccessPopup from "./success";
import {
  iniciadorActiveBanks,
  iniciadorUserAccounts,
} from "../../utils/helpers/iniciador";
import { useTranslation } from "react-i18next";
import { BanknoteArrowDown, Landmark } from "lucide-react";

const AssetInfoPage = (props) => {
  const { t } = useTranslation();
  const [productDetails, setProductDetails] = useState("overview");
  const [grahDetails, setGrahDetails] = useState("price");
  const [candleStickClicked, setCandleStickClicked] = useState(false);
  const [businessTag, setBusinessTag] = useState(null);
  const [financialTag, setFinancialTag] = useState(null);
  const [showAssetTrading, setShowAssetTrading] = useState(false);
  const [showSelectBank, setShowSelectBank] = useState(false);
  const [showCustodyAccounts, setShowCustodyAccounts] = useState(false);
  const [showUnderlyingAsset, setShowUnderlyingAsset] = useState(false);
  const [tradeType, setTradeType] = useState("");
  const [tradeCategory, setTradCategory] = useState("market");
  const [tradePrice, setTradePrice] = useState(0);
  const [tradeAmount, setTradeAmount] = useState(0);
  const [newPrice, setNewPrice] = useState(0);
  const [collateralAmount, setCollateralAmount] = useState(0);
  const [currentPrice, setCurrentPrice] = useState(
    newPrice > 0 ? newPrice : props.productClicked.currentPrice,
  );
  const [limitPrice, setLimitPrice] = useState(
    newPrice > 0 && tradeCategory === "market"
      ? newPrice
      : props.productClicked.currentPrice,
  );
  const [isTradeInput, setIsTradeInput] = useState(false);
  const [payWithVerifiedWallet, setPayWithVerifiedWallet] = useState(false);
  const [payWithBank, setPayWithBank] = useState(false);
  const [collateralAdded, setCollateralAdded] = useState(0);
  const [marginCalculationLoading, setMarginCalculationLoading] =
    useState(false);
  const [requiredCollateral, setRequiredCollateral] = useState(0);
  const [marginFees, setMarginFees] = useState({
    trade: 0,
    stoploss: 0,
    deposit: 0,
  });
  const [refereshDetails, setRefereshDetails] = useState(false);
  const [showSetCollateral, setShowSetCollateral] = useState(false);
  const [showSetCollateralType, setShowSetCollateralType] = useState("");
  const [userBalances, setUserBalances] = useState({
    security: 0.0,
    currency: 0.0,
  });
  const [sorValue, setSorValue] = useState({
    amountOut: 0.0,
    slippage: 0.0,
  });
  const [selectedCurrency, setSelectedCurrency] = useState({
    symbol: props.productClicked?.currencySymbol,
    img: "",
    decimals: props.productClicked.currencyDecimals,
    balance: 0,
    address: props.productClicked?.currency,
  });
  const [showCurrenciesDropdown, setShowCurrenciesDropdown] = useState(false);
  const [businessViewMoreClicked, setBusinessViewMoreClicked] = useState(false);
  const [paraswapDetails, setParaswapDetails] = useState({});
  const [financialViewMoreClicked, setFinancialViewMoreClicked] =
    useState(false);
  const [swapSlippage, setSwapSlippage] = useState(0.5);
  const [trySwapAgain, setTrySwapAgain] = useState(true);
  const [isMaximized, setIsMaximized] = useState(false);
  const [graphTime, setGraphTime] = useState({
    label: "1h",
    time: 60 * 60,
  });
  const [selectedBank, setSelectedBank] = useState({
    id: "",
    name: "",
    acct: "",
    logo: "",
  });
  const [selectedBankIdx, setSelectedBankIdx] = useState("");
  const [bankList, setBankList] = useState([]);
  const [bankListBr, setBankListBr] = useState([]);
  const [chartData, setChartData] = useState({
    volumeChartData: [],
    priceChartData: [],

    volumeCandleStickData: [],

    priceCandleStickData: [],
  });
  const [underlyingAssetDt, setUnderlyingAssetDt] = useState(null);
  const [userCustomerAccount, setUserCustomerAccount] = useState({
    cashAccountNumber: "",
    currency: "",
    balance: "",
    securityAccounts: [],
  });
  const [showCustomPopup, setShowCustomPopup] = useState(false);
  const [customPopupContent, setCustomPopupContent] = useState(null);
  const [customPopupPosition, setCustomPopupPosition] = useState("");
  const [currentHyperPrices, setCurrentHyperPrices] = useState({});
  const [isHyperConnected, setIsHyperConnected] = useState(false);

  const wsRef = useRef(null);

  const { chainId, provider, web3, signer } = useNetworkStore();

  const {
    setUser,
    userAddress,
    userGTNCustomerId,
    userEmail,
    userFirstName,
    userFullName,
  } = useUserStore();

  const appKitModal = useAppKit();

  const navigate = useNavigate();

  const {
    verifiedWalletDetails,
    custodyWalletDetails,
    setVerifiedWalletDetails,
    primarySubstreams,
    secondarySubstreams,
    marginSubstreams,
  } = props.generalDataProps;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleMarginCollateralAndFeeCalculation = async (
    _price,
    _tradeAmount,
  ) => {
    const poolMargin = Number(props.productClicked?.margin);
    const poolCollateral = Number(props.productClicked?.collateral);

    const price =
      tradeCategory === "limit" && Number(tradePrice) > 0
        ? tradePrice
        : tradeCategory === "limit" && limitPrice
          ? limitPrice
          : Number(_price) > 0
            ? Number(_price)
            : Number(props.productClicked.currentPrice);
    if (price === 0) {
      setRequiredCollateral(0);
      setMarginFees({
        trade: 0,
        stoploss: 0,
        deposit: 0,
      });
      return {
        trade: 0,
        stoploss: 0,
        deposit: 0,
      };
    } else {
      const cashTraded = Number(price * _tradeAmount).toFixed(4);
      const marginAmt = cashTraded * poolMargin;
      const collateralAmt = cashTraded * poolCollateral;
      const _spotlossPrice = Number(price) * Number(poolCollateral);
      const spotlossPrice =
        tradeType === "buy" ? price - _spotlossPrice : price + _spotlossPrice;
      const tradeFee = await getAndCalculateLiveFeesHyper(
        chainId,
        _tradeAmount,
        price,
        tradeCategory === "market",
      );
      const stoplossFee = await getAndCalculateLiveFeesHyper(
        chainId,
        _tradeAmount,
        spotlossPrice,
        true,
      );
      const requiredCollateral = Number(
        marginAmt + collateralAmt + tradeFee + stoplossFee,
      );
      const depositFee = await calculateMaxFastTransferAndProtocolFee(
        Number(chainDetails[chainId]?.cctpDomain || "0"),
        19,
        requiredCollateral?.toString(),
        true,
      );
      setRequiredCollateral(requiredCollateral + depositFee);
      setMarginFees({
        trade: tradeFee,
        stoploss: stoplossFee,
        deposit: depositFee,
      });
      return {
        trade: tradeFee,
        stoploss: stoplossFee,
        deposit: depositFee,
      };
    }
  };

  useEffect(() => {
    let cancelled = false;

    const handleUnderlyingAssetChart = async () => {
      setChartData({
        volumeChartData: [],
        priceChartData: [],
        volumeCandleStickData: [],
        priceCandleStickData: [],
      });

      const allTimes = new Set(); // to track duplicates globally

      const mergeAndFilter = (prev, newData) => {
        // filter out duplicates
        const priceCandles = newData.priceCandles.filter(
          (c) => !allTimes.has(c.time),
        );
        const volumeCandles = newData.volumeCandles.filter(
          (c) => !allTimes.has(c.time),
        );
        const price = newData.price.filter((c) => !allTimes.has(c.time));
        const volume = newData.volume.filter((c) => !allTimes.has(c.time));

        // add to global set
        [...priceCandles, ...volumeCandles, ...price, ...volume].forEach((c) =>
          allTimes.add(c.time),
        );

        // merge and keep ascending by time
        const sortAsc = (arr) => arr.slice().sort((a, b) => a.time - b.time);

        return {
          priceCandleStickData: sortAsc([
            ...prev.priceCandleStickData,
            ...priceCandles,
          ]),
          volumeCandleStickData: sortAsc([
            ...prev.volumeCandleStickData,
            ...volumeCandles,
          ]),
          priceChartData: sortAsc([...prev.priceChartData, ...price]),
          volumeChartData: sortAsc([...prev.volumeChartData, ...volume]),
        };
      };

      // fetch first page
      const firstRes = await fetchTickeChartData(
        props?.productClicked?.underlyingAssetId,
        props?.productClicked?.underlyingAssetId?.split("~")[0],
        0,
      );

      if (!firstRes || firstRes?.price?.length === 0) return;

      setChartData((prev) => mergeAndFilter(prev, firstRes));

      const total = Number(firstRes.numFound);
      const totalPages = Math.ceil(total / 200);

      for (let page = 1; page < totalPages; page++) {
        if (cancelled) break;

        const res = await fetchTickeChartData(
          props?.productClicked?.underlyingAssetId,
          props?.productClicked?.underlyingAssetId?.split("~")[0],
          page,
        );

        if (!res || res?.price?.length === 0) break;

        setChartData((prev) => mergeAndFilter(prev, res));
      }
    };

    if (props?.productClicked?.underlyingAssetId?.length > 0) {
      handleUnderlyingAssetChart();

      return () => {
        cancelled = true;
      };
    }
  }, [props?.productClicked]);

  useEffect(() => {
    const formatChatData = () => {
      const substreamToUse = props.productClicked?.poolType
        ?.toLowerCase()
        .startsWith("primary")
        ? primarySubstreams[props.productClicked?.address?.toLowerCase()]
        : props.productClicked?.poolType?.toLowerCase().startsWith("secondary")
          ? secondarySubstreams[props.productClicked?.address?.toLowerCase()]
          : marginSubstreams[props.productClicked?.address?.toLowerCase()];

      const _volumeCandeStick = props.productClicked?.volumeCandleStickData;

      let substreamVolumeCandleStick =
        substreamToUse?.volumeCandleStickData || [];

      const _priceCandeStick = props.productClicked?.priceCandleStickData;

      let substreamPriceCandleStick =
        substreamToUse?.priceCandleStickData || [];

      const _price = props.productClicked?.priceChartData;

      const substreamPrice = substreamToUse?.priceChartData || [];

      const _volume = props.productClicked?.volumeChartData;

      const substreamVolume = substreamToUse?.volumeChartData || [];

      //sync the open and low for first substream candlesticks
      if (Number(substreamPriceCandleStick[0]?.open) === 0) {
        substreamPriceCandleStick[0]["open"] =
          _priceCandeStick[_priceCandeStick?.length - 1]?.open;
        substreamPriceCandleStick[0]["low"] =
          _priceCandeStick[_priceCandeStick?.length - 1]?.low;
      }

      if (Number(substreamVolumeCandleStick[0]?.open) === 0) {
        substreamVolumeCandleStick[0]["open"] =
          _volumeCandeStick[_volumeCandeStick?.length - 1]?.open;
        substreamVolumeCandleStick[0]["low"] =
          _volumeCandeStick[_volumeCandeStick?.length - 1]?.low;
      }

      setChartData({
        volumeChartData: Array.from(
          new Map(
            [..._volume, ...substreamVolume].map((item) => [item.time, item]),
          ).values(),
        )?.sort((a, b) => a.time - b.time),
        priceChartData: Array.from(
          new Map(
            [..._price, ...substreamPrice].map((item) => [item.time, item]),
          ).values(),
        )?.sort((a, b) => a.time - b.time),

        volumeCandleStickData: Array.from(
          new Map(
            [..._volumeCandeStick, ...substreamVolumeCandleStick].map(
              (item) => [item.time, item],
            ),
          ).values(),
        )?.sort((a, b) => a.time - b.time),

        priceCandleStickData: Array.from(
          new Map(
            [..._priceCandeStick, ...substreamPriceCandleStick].map((item) => [
              item.time,
              item,
            ]),
          ).values(),
        )?.sort((a, b) => a.time - b.time),
      });
    };

    formatChatData();
  }, [
    primarySubstreams,
    secondarySubstreams,
    marginSubstreams,
    props.productClicked,
  ]);

  useEffect(() => {
    (async () => {
      const handleUserCustomerFetch = async () => {
        const customerDetails = await fetchCustomerDetails(userGTNCustomerId);
        if (customerDetails?.length > 0) {
          setUserCustomerAccount(customerDetails[0]);
        }
      };

      if (userGTNCustomerId?.length > 0) {
        await handleUserCustomerFetch();
      }
    })();
  }, [userGTNCustomerId]);

  useEffect(() => {
    (async () => {
      const handleBankList = async () => {
        setBankListBr(await iniciadorActiveBanks());
        setBankList(await blinkActiveBanks());
      };

      await handleBankList();
    })();
  }, []);

  useEffect(() => {
    const handleSetTags = () => {
      const businessPTag = document.getElementById(
        "asset-info-popup-business-summary",
      );
      const financialPTag = document.getElementById(
        "asset-info-popup-financial-summary",
      );
      if (businessPTag) {
        setBusinessTag(businessPTag);
      }
      if (financialPTag) {
        setFinancialTag(financialPTag);
      }
    };

    handleSetTags();

    return () => {};
  });

  useEffect(() => {
    const handleParaswapRate = async () => {
      let tokenFrom, tokenTo, tokenFromDecimals, amountToSwap;
      if (tradeType === "sell") {
        tokenFrom = props.productClicked.currency;
        tokenFromDecimals = Number(props.productClicked.currencyDecimals);
        tokenTo = selectedCurrency.address;
        amountToSwap = Number(sorValue.amountOut);
      } else if (tradeType === "buy") {
        tokenFrom = selectedCurrency.address;
        tokenFromDecimals = Number(selectedCurrency.decimals);
        tokenTo = props.productClicked.currency;

        amountToSwap =
          props.productClicked.poolType === PoolType.secondaryPool
            ? Number(tradeAmount)
            : props.productClicked.poolType === PoolType.primaryPool
              ? Number(sorValue.amountOut)
              : 0;
      }

      if (amountToSwap > 0) {
        const paraswapRate = await getTokensSwapRate(
          userAddress,
          chainId,
          provider,
          tradeType,
          tokenFrom,
          tokenTo,
          tokenFromDecimals,
          amountToSwap,
          swapSlippage,
        );
        setParaswapDetails(paraswapRate);
      } else {
        setParaswapDetails({});
      }
    };

    if (
      userAddress &&
      chainId > 0 &&
      signer &&
      props?.productClicked?.currency &&
      selectedCurrency?.address?.length > 0 &&
      selectedCurrency.address !== props.productClicked.currency &&
      props.productClicked?.poolType !== PoolType.marginPool &&
      trySwapAgain
    ) {
      handleParaswapRate();
    } else if (!trySwapAgain) {
      setParaswapDetails({ amount: 0 });
    } else {
      setParaswapDetails({});
    }
  }, [
    userAddress,
    chainId,
    provider,
    props.productClicked.currency,
    props.productClicked.currencyDecimals,
    selectedCurrency.address,
    selectedCurrency.decimals,
    sorValue,
    tradeAmount,
    tradeType,
    props.productClicked.poolType,
    trySwapAgain,
    swapSlippage,
    signer,
    refereshDetails,
  ]);

  useEffect(() => {
    const getBalances = async () => {
      let securityBalance, currencyBalance;
      if (
        userAddress?.length > 0 &&
        props.productClicked.security?.length > 0 &&
        web3
      ) {
        const securityBalanceRaw = await new web3.eth.Contract(
          ERC20ABI,
          props.productClicked?.security,
        ).methods
          .balanceOf(userAddress)
          .call();
        securityBalance = ethers.utils.formatUnits(
          securityBalanceRaw,
          props.productClicked.securityDecimals,
        );
      }
      if (userAddress && selectedCurrency.address?.length > 0 && web3) {
        const currencyBalanceRaw = await new web3.eth.Contract(
          ERC20ABI,
          selectedCurrency.address,
        ).methods
          .balanceOf(userAddress)
          .call();
        currencyBalance = ethers.utils.formatUnits(
          currencyBalanceRaw,
          selectedCurrency.decimals.toString(),
        );
      }

      setUserBalances({
        security: securityBalance || "0",
        currency: currencyBalance || "0",
      });
    };

    getBalances();
  }, [
    props.productClicked.security,
    props.productClicked.securityDecimals,
    props.productClicked.currency,
    props.productClicked.currencyDecimals,
    web3,
    userAddress,
    selectedCurrency.address,
    selectedCurrency.decimals,
    showSetCollateral,
    refereshDetails,
  ]);

  useEffect(() => {
    if (
      props.productClicked?.securityCategory?.toLowerCase() === "cfd" &&
      props.productClicked?.cfiCode?.length > 0 &&
      props.productClicked?.cfiCode === "HYPERLIQUID"
    ) {
      const wsUrl =
        process.env.REACT_APP_NODE_ENV === "production"
          ? "wss://api.hyperliquid.xyz/ws"
          : "wss://api.hyperliquid-testnet.xyz/ws";
      wsRef.current = new WebSocket(wsUrl);

      wsRef.current.onopen = () => {
        setIsHyperConnected(true);

        const subscribeMessage = {
          method: "subscribe",
          subscription: { type: "allMids" },
        };
        wsRef.current?.send(JSON.stringify(subscribeMessage));
      };

      wsRef.current.onmessage = (event) => {
        const response = JSON.parse(event.data);

        if (response.channel === "allMids" && response.data?.mids) {
          setCurrentHyperPrices(
            Object.assign(
              {},
              ...Object.entries(response.data.mids)
                .filter(
                  ([mid]) =>
                    mid === props.productClicked.securitySymbol &&
                    !mid.startsWith("#") &&
                    !mid.startsWith("@"),
                )
                .map(([mid, value]) => ({ [mid]: value })),
            ),
          );
        }
      };

      // 4. Event listener: Handle connection closure
      wsRef.current.onclose = () => {
        setIsHyperConnected(false);
      };
    }

    return () => {
      if (wsRef.current) {
        wsRef.current.close();
      }
    };
  }, [
    props.productClicked?.cfiCode,
    props.productClicked?.securityCategory,
    props.productClicked.securitySymbol,
  ]);

  useEffect(() => {
    const fetchMarginCurrentPrice = async () => {
      if (
        props.productClicked?.securityCategory?.toLowerCase() === "cfd" &&
        props.productClicked?.cfiCode?.length > 0 &&
        props.productClicked?.cfiCode !== "HYPERLIQUID"
      ) {
        const currencyFiat = props.productClicked.currencySymbol
          ?.toLowerCase()
          ?.startsWith("vc")
          ? currenciesToFiat[
              props.productClicked.currencySymbol
                ?.toLowerCase()
                ?.replace("vc", "")
                ?.toUpperCase()
            ]
          : currenciesToFiat[
              props.productClicked.currencySymbol?.toLowerCase()?.toUpperCase()
            ];
        await fetchTokenPriceFromVerified(
          props.productClicked?.cfiCode,
          props.productClicked.securitySymbol,
          currencyFiat,
          tradeType,
        ).then(async (res) => {
          if (Number(res) > 0) {
            setNewPrice(Number(res));
            setCurrentPrice(Number(res));
            if (tradeCategory === "market") {
              setLimitPrice(Number(res));
            }

            //recalculate required collateral and fees
            const _tradeAmount = Number(tradeAmount);
            if (_tradeAmount > 0) {
              const fees = await handleMarginCollateralAndFeeCalculation(
                res,
                _tradeAmount,
              );
              if (fees.trade === 0 || fees.stoploss === 0) {
                await handleMarginCollateralAndFeeCalculation(
                  res,
                  _tradeAmount,
                );
              }
            }
          } else {
            await fetchTokenPriceCoinbase(
              tokenGcexAlias[
                props.productClicked?.securitySymbol?.toUpperCase()
              ]
                ? tokenGcexAlias[
                    props.productClicked?.securitySymbol?.toUpperCase()
                  ]
                : props.productClicked?.securitySymbol,
              currencyFiat,
            ).then(async (_res) => {
              if (Number(_res) > 0) {
                setNewPrice(Number(_res));
                setCurrentPrice(Number(_res));
                if (tradeCategory === "market") {
                  setLimitPrice(Number(_res));
                }
                //recalculate required collateral and fees
                const _tradeAmount = Number(tradeAmount);
                if (_tradeAmount > 0) {
                  const fees = await handleMarginCollateralAndFeeCalculation(
                    _res,
                    _tradeAmount,
                  );
                  if (fees.trade === 0 || fees.stoploss === 0) {
                    await handleMarginCollateralAndFeeCalculation(
                      _res,
                      _tradeAmount,
                    );
                  }
                }
              } else {
                await fetchTokenPriceCoingecko(
                  props.productClicked.securityTokenCoingeckoId,
                  currencyFiat,
                ).then(async (__res) => {
                  if (Number(__res) > 0) {
                    setNewPrice(Number(__res));
                    setCurrentPrice(Number(__res));
                    if (tradeCategory === "market") {
                      setLimitPrice(Number(__res));
                    }
                    //recalculate required collateral and fees
                    const _tradeAmount = Number(tradeAmount);
                    if (_tradeAmount > 0) {
                      const fees =
                        await handleMarginCollateralAndFeeCalculation(
                          __res,
                          _tradeAmount,
                        );
                      if (fees.trade === 0 || fees.stoploss === 0) {
                        await handleMarginCollateralAndFeeCalculation(
                          __res,
                          _tradeAmount,
                        );
                      }
                    }
                  } else {
                    setNewPrice(Number(props.productClicked?.currentPrice));
                    setCurrentPrice(Number(props.productClicked?.currentPrice));
                    if (tradeCategory === "market") {
                      setLimitPrice(Number(props.productClicked?.currentPrice));
                    }

                    //recalculate required collateral and fees
                    const _tradeAmount = Number(tradeAmount);
                    if (_tradeAmount > 0) {
                      const fees =
                        await handleMarginCollateralAndFeeCalculation(
                          "0",
                          _tradeAmount,
                        );
                      if (fees.trade === 0 || fees.stoploss === 0) {
                        await handleMarginCollateralAndFeeCalculation(
                          "0",
                          _tradeAmount,
                        );
                      }
                    }
                  }
                });
              }
            });
          }
        });
      } else if (
        props.productClicked?.securityCategory?.toLowerCase() === "cfd" &&
        props.productClicked?.cfiCode?.length > 0 &&
        props.productClicked?.cfiCode === "HYPERLIQUID" &&
        currentHyperPrices[props.productClicked.securitySymbol]
      ) {
        const hyperPrice =
          currentHyperPrices[props.productClicked.securitySymbol] || "0";

        setNewPrice(Number(hyperPrice));
        setCurrentPrice(Number(hyperPrice));
        if (tradeCategory === "market") {
          setLimitPrice(Number(hyperPrice));
        }
        //recalculate required collateral and fees
        const _tradeAmount = Number(tradeAmount);
        if (_tradeAmount > 0) {
          const fees = await handleMarginCollateralAndFeeCalculation(
            hyperPrice,
            _tradeAmount,
          );
          if (fees.trade === 0 || fees.stoploss === 0) {
            await handleMarginCollateralAndFeeCalculation(
              hyperPrice,
              _tradeAmount,
            );
          }
        }
      } else {
        setNewPrice(Number(props.productClicked?.currentPrice));
        setCurrentPrice(Number(props.productClicked?.currentPrice));
        if (tradeCategory === "market") {
          setLimitPrice(Number(props.productClicked?.currentPrice));
        }

        //recalculate required collateral and fees
        const _tradeAmount = Number(tradeAmount);
        if (_tradeAmount > 0) {
          const fees = await handleMarginCollateralAndFeeCalculation(
            "0",
            _tradeAmount,
          );
          if (fees.trade === 0 || fees.stoploss === 0) {
            await handleMarginCollateralAndFeeCalculation("0", _tradeAmount);
          }
        }
      }
    };

    const fetchMarginCollateralBalance = async () => {
      const marginManagerContract = new web3.eth.Contract(
        MARGINMANAGERABI,
        contractAddress[chainId].BalancerMarginIssueManager,
      );
      const userCollateral = await marginManagerContract.methods
        .getUserCollateral(userAddress, props.productClicked.currency)
        .call();

      const userCollateralFmt = Number(
        ethers.utils.formatUnits(
          userCollateral?.toString(),
          Number(props.productClicked?.currencyDecimals),
        ),
      );
      setCollateralAdded(
        userCollateralFmt?.toFixed(
          Number(props.productClicked?.currencyDecimals),
        ),
      );
    };

    if (
      props.productClicked.currencySymbol &&
      props.productClicked.securitySymbol
    ) {
      fetchMarginCurrentPrice();
    }

    if (
      chainId &&
      web3 &&
      props.productClicked?.currency &&
      userAddress?.length > 0 &&
      contractAddress[chainId].BalancerMarginIssueManager?.length > 0
    ) {
      fetchMarginCollateralBalance();
    }
  }, [
    props.productClicked.currencySymbol,
    props.productClicked.securitySymbol,
    props.productClicked?.securityCategory,
    props.productClicked?.cfiCode,
    web3,
    tradeType,
    props.productClicked.currency,
    chainId,
    userAddress,
    showSetCollateral,
    props.productClicked.securityTokenCoingeckoId,
    props.productClicked?.currentPrice,
    refereshDetails,
    props.productClicked?.currencyDecimals,
    currentHyperPrices,
    tradeAmount,
    tradeCategory,
  ]);

  const updatePointerPosition = (price, defaultPosition) => {
    const pointer = document.getElementById("price-range-page-container");
    const pointerDiv = document.getElementById("price-range-page");
    const pointerText = document.getElementById("price-range-page-text");
    const pointerDot = document.getElementById("price-range-line-dot");
    const rangeDiv = document.getElementById("price-range-line");

    if (pointer && pointerDiv && pointerText && pointerDot && rangeDiv) {
      const pointerWidth = pointer.offsetWidth;
      const newPosition =
        ((price - Number(props.productClicked?.lowestPrice)) /
          (Number(props.productClicked?.highestPrice) -
            Number(props.productClicked?.lowestPrice))) *
        pointerWidth;
      pointerDot.style.left = defaultPosition
        ? `${rangeDiv.offsetWidth / 2 + pointerDiv.offsetWidth / 2}px`
        : `${newPosition - pointerDot.offsetWidth / 2}px`;
      pointerDiv.style.left = defaultPosition
        ? `${rangeDiv.offsetWidth / 2 - pointerDiv.offsetWidth / 2}px`
        : `${newPosition - pointerDiv.offsetWidth / 2}px`;
      pointerText.innerText = `${price} ${props.productClicked?.currencyFiatSymbol}`;
    }
  };

  return (
    <React.Fragment>
      {showCustomPopup && (
        <GeneralPopupBackground
          popupContent={customPopupContent}
          popupContentPosition={
            customPopupPosition !== "" ? customPopupPosition : "center"
          }
        />
      )}

      <div
        style={
          isMaximized && document.getElementById("side-bar-id")
            ? {
                width: `${
                  Number(window.innerWidth) -
                  (Number(document.getElementById("side-bar-id").offsetWidth) +
                    36)
                }px`,
              }
            : {}
        }
        id="asset-info-id"
        className="search-filter-popup"
      >
        <div className="search-filter-popup-content">
          <div className="asset-info-popup-header">
            <div className="asset-info-popup-header-main">
              <div className="asset-info-popup-header-main-text">
                {!showSetCollateral && (
                  <>
                    {!showAssetTrading && (
                      <p className="search-filter-popup-header-text">
                        {t("header.assetDetails")}
                      </p>
                    )}
                    {showAssetTrading && (
                      <>
                        <img
                          onClick={() => {
                            setTradeType("");
                            setShowAssetTrading(false);
                            setTradCategory("market");
                            setTradePrice(null);
                            setTradeAmount(0);
                            setIsTradeInput(false);
                            setPayWithVerifiedWallet(false);
                            setPayWithBank(false);
                            setSelectedCurrency({
                              symbol: props.productClicked?.currencySymbol,
                              img: "",
                              decimals: props.productClicked.currencyDecimals,
                              balance: 0,
                              address: props.productClicked?.currency,
                            });
                            setMarginFees({ trade: 0, stoploss: 0 });
                            setRequiredCollateral(0);
                          }}
                          alt="Back Icon"
                          src={backIcon}
                        />
                        {tradeType === "buy" && (
                          <p className="search-filter-popup-header-text">
                            {t("header.buyAsset")}
                          </p>
                        )}
                        {tradeType === "sell" && (
                          <p className="search-filter-popup-header-text">
                            {t("header.sellAsset")}
                          </p>
                        )}
                      </>
                    )}
                  </>
                )}
                {showSetCollateral && showSelectBank && (
                  <>
                    <img
                      onClick={() => {
                        setShowSetCollateral(false);
                        setPayWithBank(false);
                        setPayWithVerifiedWallet(false);
                        setShowSelectBank(false);
                        setShowCustodyAccounts(false);
                      }}
                      alt="Back Icon"
                      src={backIcon}
                    />
                    {showCustodyAccounts ? (
                      <p className="search-filter-popup-header-text">
                        Confirm Bank Account(s)
                      </p>
                    ) : (
                      <p className="search-filter-popup-header-text">
                        {t("selectBank.selectBank")}
                      </p>
                    )}
                  </>
                )}
                {showSetCollateral &&
                  !showSelectBank &&
                  !showUnderlyingAsset && (
                    <>
                      <img
                        onClick={() => {
                          setShowSetCollateral(false);
                          setPayWithBank(false);
                          setPayWithVerifiedWallet(false);
                        }}
                        alt="Back Icon"
                        src={backIcon}
                      />
                      {showSetCollateralType === "withdraw" && (
                        <p className="search-filter-popup-header-text">
                          Withdraw Collateral
                        </p>
                      )}
                      {showSetCollateralType === "deposit" && (
                        <p className="search-filter-popup-header-text">
                          Add Collateral
                        </p>
                      )}
                      {showSetCollateralType === "" && (
                        <p className="search-filter-popup-header-text">
                          Set Collateral
                        </p>
                      )}
                    </>
                  )}
                {showSetCollateral && showUnderlyingAsset && (
                  <>
                    <img
                      onClick={() => {
                        setShowSetCollateral(false);
                        setPayWithBank(false);
                        setPayWithVerifiedWallet(false);
                      }}
                      alt="Back Icon"
                      src={backIcon}
                    />
                    <p className="search-filter-popup-header-text">
                      {t("assetInfo.youAreAboutTo")}{" "}
                      {tradeType === "buy"
                        ? t("assetInfo.buy")
                        : tradeType === "sell"
                          ? t("assetInfo.sell")
                          : ""}
                    </p>
                  </>
                )}
              </div>
              <div className="asset-info-popup-icons">
                {!isMaximized && (
                  <img
                    onClick={() => {
                      props.setExpandedView(true);
                      setIsMaximized(true);
                    }}
                    alt="Close Icon"
                    src={maximizeIcon}
                  />
                )}
                {isMaximized && (
                  <img
                    onClick={() => {
                      props.setExpandedView(false);
                      setIsMaximized(false);
                    }}
                    alt="Close Icon"
                    src={minimizeIcon}
                  />
                )}
                <img
                  onClick={() => {
                    props.setShowPopup(false);
                    props.setPopupContentPosition("center");
                    props.setPopupContent(null);
                    if (props.setFavouriteClicked) {
                      props.setFavouriteClicked(false);
                    }
                    setTradeType("");
                    setTradCategory("market");
                    setTradePrice(null);
                    setTradeAmount(0);
                    setIsTradeInput(false);
                    setPayWithVerifiedWallet(false);
                    setPayWithBank(false);
                  }}
                  alt="Close Icon"
                  src={popupCloseIcon}
                />
              </div>
            </div>

            {!showAssetTrading && !showSetCollateral && (
              <div className="asset-info-popup-header-body">
                <div
                  onClick={() => {
                    setProductDetails("overview");
                  }}
                  className="asset-info-popup-header-menu"
                >
                  {productDetails === "overview" && (
                    <>
                      <p className="asset-info-popup-header-menu-text-active">
                        {t("assetInfo.overview")}
                      </p>
                      <div className="asset-info-popup-header-menu-line"></div>
                    </>
                  )}
                  {productDetails !== "overview" && (
                    <p className="asset-info-popup-header-menu-text">
                      {t("assetInfo.overview")}
                    </p>
                  )}
                </div>
                <div
                  onClick={() => {
                    setProductDetails("fundamentals");
                  }}
                  className="asset-info-popup-header-menu"
                >
                  {productDetails === "fundamentals" && (
                    <>
                      <p className="asset-info-popup-header-menu-text-active">
                        {t("assetInfo.fundamentals")}
                      </p>{" "}
                      <div className="asset-info-popup-header-menu-line"></div>
                    </>
                  )}
                  {productDetails !== "fundamentals" && (
                    <p className="asset-info-popup-header-menu-text">
                      {t("assetInfo.fundamentals")}
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>

          {!showSetCollateral && (
            <div className="asset-info-popup-body">
              <div className="asset-info-popup-first">
                <div className="asset-info-popup-first-header">
                  <div className="asset-info-popup-first-header-title">
                    <div className="asset-info-popup-first-header-icon">
                      {props.productClicked.logo && (
                        <img
                          alt="Product Logo"
                          src={props.productClicked.logo}
                        />
                      )}
                      {!props.productClicked.logo && (
                        <Avatar name={props.productClicked.securitySymbol} />
                      )}
                    </div>
                    <div className="asset-info-popup-first-header-texts">
                      <p className="asset-info-popup-first-product-name">
                        {props.productClicked.securitySymbol}
                      </p>
                      <p className="asset-info-popup-first-product-description">
                        {props.productClicked.securityName}
                      </p>
                    </div>
                  </div>
                  <div className="asset-info-popup-first-header-price">
                    <p className="asset-info-popup-first-price-header">
                      {props.productClicked?.currencyFiatSymbol}{" "}
                      {Number(newPrice) > 0
                        ? formatNumberAsPrice(newPrice)
                        : formatNumberAsPrice(
                            props.productClicked.currentPrice,
                          )}
                    </p>
                    <p
                      style={
                        Number(
                          newPrice > 0
                            ? newPrice
                            : props.productClicked.currentPrice,
                        ) <
                        Number(
                          props.productClicked.pricesBeforeTodayFmt
                            ?.priceBeforeToday,
                        )
                          ? { color: "#BC1919" }
                          : {}
                      }
                      className="asset-info-popup-first-price-footer"
                    >
                      {Number(
                        newPrice > 0
                          ? newPrice
                          : props.productClicked.currentPrice,
                      ) >=
                      Number(
                        props.productClicked.pricesBeforeTodayFmt
                          ?.priceBeforeToday,
                      )
                        ? (
                            Number(
                              newPrice > 0
                                ? newPrice
                                : props.productClicked.currentPrice,
                            ) -
                            Number(
                              props.productClicked.pricesBeforeTodayFmt
                                ?.priceBeforeToday,
                            )
                          ).toFixed(2)
                        : (
                            Number(
                              props.productClicked.pricesBeforeTodayFmt
                                ?.priceBeforeToday,
                            ) -
                            Number(
                              newPrice > 0
                                ? newPrice
                                : props.productClicked.currentPrice,
                            )
                          ).toFixed(2)}{" "}
                      ({" "}
                      {Number(
                        newPrice > 0
                          ? newPrice
                          : props.productClicked.currentPrice,
                      ) >=
                      Number(
                        props.productClicked.pricesBeforeTodayFmt
                          ?.priceBeforeToday,
                      )
                        ? `+ ${(
                            ((Number(
                              newPrice > 0
                                ? newPrice
                                : props.productClicked.currentPrice,
                            ) -
                              Number(
                                props.productClicked.pricesBeforeTodayFmt
                                  ?.priceBeforeToday,
                              )) *
                              100) /
                              Number(
                                newPrice > 0
                                  ? newPrice
                                  : props.productClicked.currentPrice,
                              ) || 0
                          ).toFixed(2)}`
                        : `- ${(
                            ((Number(
                              props.productClicked.pricesBeforeTodayFmt
                                ?.priceBeforeToday,
                            ) -
                              Number(
                                newPrice > 0
                                  ? newPrice
                                  : props.productClicked.currentPrice,
                              )) *
                              100) /
                              Number(
                                props.productClicked.pricesBeforeTodayFmt
                                  ?.priceBeforeToday,
                              ) || 0
                          ).toFixed(2)}`}{" "}
                      % )
                    </p>
                  </div>
                </div>

                {!props.showPandL && (
                  <>
                    <div className="asset-info-popup-first-footer">
                      <div className="asset-info-popup-first-footer-content">
                        <p className="asset-info-popup-first-footer-content-header">
                          {t("assetInfo.minimumQuantity")}
                        </p>
                        <p className="asset-info-popup-first-footer-content-footer">
                          {Number(props.productClicked.minOrderSize).toFixed(4)}
                        </p>
                      </div>

                      <div className="asset-info-popup-first-footer-line">
                        <div className="asset-info-popup-first-footer-content">
                          <p className="asset-info-popup-first-footer-content-header">
                            {t("assetInfo.totalVolume")}
                          </p>
                          <p className="asset-info-popup-first-footer-content-footer">
                            {props.productClicked?.tvl}
                          </p>
                        </div>
                      </div>

                      <div className="asset-info-popup-first-footer-content">
                        <p className="asset-info-popup-first-footer-content-header">
                          {t("assetInfo.issueType")}
                        </p>
                        <p className="asset-info-popup-first-footer-content-footer">
                          {props.productClicked.poolType}
                        </p>
                      </div>
                    </div>
                    {props.showSeparator && (
                      <PageSeperator
                        separatorText={props.separatorText}
                        separatorWidth={props.separatorWidth}
                      />
                    )}
                  </>
                )}

                {props.showPandL && !props.productClicked.isMarginIssue && (
                  <div className="asset-info-popup-p-and-l">
                    <div className="asset-info-popup-p-and-l-content">
                      <div className="asset-info-popup-p-and-l-content-section">
                        <p className="asset-info-popup-p-and-l-content-title">
                          Total Qty
                        </p>
                        <p className="asset-info-popup-p-and-l-content-text">
                          {Number(
                            props.productClicked.totalInvestorBalance,
                          ).toFixed(4)}
                        </p>
                      </div>
                      <div className="asset-info-popup-p-and-l-content-section">
                        <p className="asset-info-popup-p-and-l-content-title">
                          P&L
                        </p>
                        <div className="asset-info-popup-p-and-l-content-text-container">
                          <p className="asset-info-popup-p-and-l-content-text-gain">
                            $62.64
                          </p>
                          <img src={priceUp} alt="Arrow Up Icon" />
                        </div>
                      </div>
                    </div>
                    <div className="asset-info-popup-p-and-l-content">
                      <div className="asset-info-popup-p-and-l-content-section">
                        <p className="asset-info-popup-p-and-l-content-title">
                          Total Amt Invested
                        </p>
                        <p className="asset-info-popup-p-and-l-content-text">
                          1440.00
                        </p>
                      </div>
                      <div className="asset-info-popup-p-and-l-content-section">
                        <p className="asset-info-popup-p-and-l-content-title">
                          Margin
                        </p>
                        <p className="asset-info-popup-p-and-l-content-text">
                          {Number(props.productClicked?.margin) * 100} %
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {props.showPandL &&
                  props.productClicked.isMarginIssue &&
                  props.showMarginExtra && (
                    <>
                      <div className="asset-info-popup-p-and-l-content">
                        <div className="asset-info-popup-p-and-l-content-section">
                          <p className="asset-info-popup-p-and-l-content-title">
                            Current Value
                          </p>
                          <p className="asset-info-popup-p-and-l-content-text">
                            8105
                          </p>
                        </div>
                        <div className="asset-info-popup-p-and-l-content-section">
                          <p className="asset-info-popup-p-and-l-content-title">
                            P&L
                          </p>
                          <div className="asset-info-popup-p-and-l-content-text-container">
                            <p className="asset-info-popup-p-and-l-content-text-gain">
                              $105.50
                            </p>
                            <img src={priceUp} alt="Arrow Up Icon" />
                          </div>
                        </div>
                      </div>

                      {tradeType !== "buy" && (
                        <>
                          <div className="asset-info-popup-p-and-l-content">
                            <div className="asset-info-popup-p-and-l-content-section">
                              <p className="asset-info-popup-p-and-l-content-title">
                                Collateral Value
                              </p>
                              <p className="asset-info-popup-p-and-l-content-text">
                                2000
                              </p>
                            </div>
                            <div className="asset-info-popup-p-and-l-content-section">
                              <p className="asset-info-popup-p-and-l-content-title">
                                Margin Received
                              </p>
                              <div className="asset-info-popup-p-and-l-content-text-container">
                                <p className="asset-info-popup-p-and-l-content-text-gain">
                                  6000
                                </p>
                                <img src={priceUp} alt="Arrow Up Icon" />
                              </div>
                            </div>
                          </div>
                          <div className="asset-info-popup-p-and-l-content">
                            <div className="asset-info-popup-p-and-l-content-section">
                              <p className="asset-info-popup-p-and-l-content-title">
                                Total Qty
                              </p>
                              <p className="asset-info-popup-p-and-l-content-text">
                                10
                              </p>
                            </div>
                            <div className="asset-info-popup-p-and-l-content-section">
                              <p className="asset-info-popup-p-and-l-content-title">
                                P&L Settlement Frequency
                              </p>
                              <p className="asset-info-popup-p-and-l-content-text">
                                3 Days
                              </p>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  )}

                {props.showPandL &&
                  props.productClicked.isMarginIssue &&
                  !props.showMarginExtra && (
                    <div className="asset-info-popup-p-and-l">
                      <div className="asset-info-popup-p-and-l-content">
                        <div className="asset-info-popup-p-and-l-content-section">
                          <p className="asset-info-popup-p-and-l-content-title">
                            Financing Cost
                          </p>
                          <p className="asset-info-popup-p-and-l-content-text">
                            20% (of current price)
                          </p>
                        </div>
                        <div className="asset-info-popup-p-and-l-content-section">
                          <p className="asset-info-popup-p-and-l-content-title">
                            Margin Available
                          </p>
                          <p className="asset-info-popup-p-and-l-content-text">
                            {" "}
                            4x (of financing cost)
                          </p>
                        </div>
                      </div>

                      {tradeType !== "buy" && (
                        <div className="asset-info-popup-p-and-l-content">
                          <div className="asset-info-popup-p-and-l-content-section">
                            <p className="asset-info-popup-p-and-l-content-title">
                              Minimum Quantity
                            </p>
                            <p className="asset-info-popup-p-and-l-content-text">
                              1440.00
                            </p>
                          </div>
                          <div className="asset-info-popup-p-and-l-content-section">
                            <p className="asset-info-popup-p-and-l-content-title">
                              P&L Settlement Frequency
                            </p>
                            <p className="asset-info-popup-p-and-l-content-text">
                              3 Days
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                {showAssetTrading && (
                  <>
                    {props.productClicked.poolType === PoolType.marginPool && (
                      <div className="asset-info-popup-collateral-container">
                        <p className="asset-info-popup-collateral-header-text">
                          {t("assetInfo.collateralDetails")}
                        </p>
                        <div className="asset-info-popup-collateral-body">
                          <div className="asset-info-popup-collateral-main">
                            <div className="asset-info-popup-collateral-main-first">
                              <div className="asset-info-popup-collateral-main-first-header">
                                <p className="asset-info-popup-collateral-main-title">
                                  {t("withdrawFunds.balance")}
                                </p>
                                <p className="asset-info-popup-collateral-main-first-text">
                                  {collateralAdded}{" "}
                                  {props.productClicked?.currencyFiatSymbol}
                                </p>
                              </div>
                              <div className="asset-info-popup-collateral-main-first-footer">
                                <p className="asset-info-popup-collateral-main-title">
                                  {/* {t("loans.collateral")} */}
                                  Stoploss
                                </p>
                                <p className="asset-info-popup-collateral-main-second-footer">
                                  {Number(props.productClicked?.collateral) *
                                    100}{" "}
                                  %
                                </p>
                              </div>
                            </div>
                            <div
                              onClick={() => {
                                // setIsCollateralAdded(true);
                                setShowSetCollateralType("deposit");
                                setShowSetCollateral(true);
                                setShowSelectBank(false);
                              }}
                              className="asset-info-popup-collateral-main-second"
                            >
                              <div className="asset-info-popup-collateral-main-second-container">
                                <img src={collateralBank} alt="Expand Icon" />
                                <p className="asset-info-popup-collateral-main-second-text">
                                  {t("assetInfo.collateral")}
                                </p>
                              </div>
                              <img src={collateralExpand} alt="Expand Icon" />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div
                      style={
                        props.productClicked &&
                        props.productClicked.isMarginIssue &&
                        Number(collateralAdded) === 0
                          ? {
                              opacity: "0.5",
                              background: "#FFF",
                              pointerEvents: "none",
                            }
                          : {}
                      }
                      className="asset-info-popup-trading-container"
                    >
                      <div className="asset-info-popup-trading-first-header">
                        <div
                          style={{ position: "relative" }}
                          className="asset-info-popup-trading-first-header-text-container"
                        >
                          <p className="asset-info-popup-trading-first-header-text">
                            {tradeType === "buy" ? "Buy With" : "Sell To"}
                          </p>
                          <div
                            style={{
                              zIndex: "2",
                              position: "absolute",
                              top: "-8px",
                              right: "0",
                            }}
                            className="asset-info-popup-trading-first-header-dropdown-cont"
                          >
                            <button
                              onClick={() => {
                                setShowCurrenciesDropdown(
                                  !showCurrenciesDropdown,
                                );
                              }}
                              className="portfolio-page-content-header-button"
                            >
                              {selectedCurrency.img.length > 0 && (
                                <div className="asset-info-popup-trading-first-header-dropdown-content-img">
                                  <img src={selectedCurrency.img} alt="" />
                                </div>
                              )}
                              <p className="portfolio-page-content-header-button-text">
                                {selectedCurrency.symbol}
                              </p>
                              <img src={expandIcon} alt="Expand Icon" />
                            </button>
                            {showCurrenciesDropdown &&
                              props.paraswapSupportedTokens?.length > 0 &&
                              props.paraswapSupportedTokens?.find(
                                (tk) =>
                                  tk?.address?.toLowerCase() ===
                                  props?.productClicked?.currency.toLowerCase(),
                              ) && (
                                <div className="asset-info-popup-trading-first-header-dropdown">
                                  {props.paraswapSupportedTokens?.map((ptk) => (
                                    <div
                                      onClick={() => {
                                        setSelectedCurrency(ptk);
                                        setShowCurrenciesDropdown(false);
                                      }}
                                      className="asset-info-popup-trading-first-header-dropdown-content"
                                    >
                                      <div className="asset-info-popup-trading-first-header-dropdown-content-img">
                                        <img src={ptk.img} alt="" />
                                      </div>

                                      <p className="portfolio-page-content-header-button-text">
                                        {ptk.symbol}
                                      </p>
                                    </div>
                                  ))}
                                </div>
                              )}
                          </div>
                        </div>
                        <div
                          style={{ marginTop: "5px" }}
                          className="asset-info-popup-trading-first-header-text-container"
                        >
                          {props.productClicked.poolType !==
                            PoolType.secondaryPool && (
                            <p className="asset-info-popup-trading-first-header-text">
                              {`No. of ${
                                props.productClicked.securitySymbol
                              } to ${tradeType === "buy" ? t("assetInfo.buy") : tradeType === "sell" ? t("assetInfo.sell") : ""}`}
                            </p>
                          )}
                          {props.productClicked.poolType ===
                            PoolType.secondaryPool && (
                            <p className="asset-info-popup-trading-first-header-text">
                              {`No. of ${
                                tradeType === "buy"
                                  ? selectedCurrency.symbol
                                  : props.productClicked.securitySymbol
                              } to ${
                                tradeType === "buy"
                                  ? `${t("assetInfo.buyWith")}`
                                  : `${t("assetInfo.sell")}`
                              }`}
                            </p>
                          )}

                          {props.productClicked.poolType ===
                            PoolType.marginPool && tradeType === "sell" ? (
                            <></>
                          ) : (
                            <p className="asset-info-popup-trading-first-header-text-footer">
                              Max Qty:{" "}
                              {tradeType === "buy"
                                ? Number(userBalances.currency)?.toFixed(6)
                                : Number(userBalances.security)?.toFixed(
                                    6,
                                  )}{" "}
                              {tradeType === "buy"
                                ? selectedCurrency.symbol
                                : props.productClicked.securitySymbol}
                            </p>
                          )}
                        </div>
                        <input
                          type="number"
                          className="asset-info-popup-trading-input"
                          placeholder="0"
                          value={tradeAmount === 0 ? "" : tradeAmount}
                          onInput={async (e) => {
                            setTradeAmount(e.target.value);
                            if (
                              props.productClicked.poolType !==
                                PoolType.marginPool &&
                              Number(e.target.value) > 0
                            ) {
                              const sorValue =
                                await calculatePrimaryAndSecondarySOR(
                                  props.productClicked,
                                  Number(e.target.value),
                                  tradeType,
                                  userAddress,
                                );
                              setSorValue(sorValue);
                            } else {
                              if (
                                props.productClicked.poolType ===
                                PoolType.marginPool
                              ) {
                                setMarginCalculationLoading(true);

                                //recalculate required collateral and fees
                                const _tradeAmount = Number(e.target.value);
                                if (_tradeAmount > 0) {
                                  const fees =
                                    await handleMarginCollateralAndFeeCalculation(
                                      newPrice,
                                      _tradeAmount,
                                    );
                                  if (fees.trade === 0 || fees.stoploss === 0) {
                                    await handleMarginCollateralAndFeeCalculation(
                                      newPrice,
                                      _tradeAmount,
                                    );
                                  }
                                }

                                setMarginCalculationLoading(false);
                              }
                              setSorValue({ amountOut: 0.0, slippage: 0.0 });
                            }
                          }}
                        />

                        {Number(tradeAmount) > 0 && (
                          <>
                            {props.productClicked.poolType ===
                              PoolType.primaryPool &&
                              Number(currentPrice) > 0 && (
                                <p
                                  style={{
                                    width: "100%",
                                    wordWrap: "break-word",
                                    color: "#4e2bd7",
                                  }}
                                  className="asset-info-popup-trading-first-header-text"
                                >
                                  {tradeType === "buy"
                                    ? `${t("assetInfo.payApproximate")} ${Number(
                                        Number(tradeAmount) *
                                          Number(currentPrice),
                                      )?.toFixed(6)} ${
                                        selectedCurrency.symbol
                                      } ${t("assetInfo.forCustom")} ${Number(tradeAmount)} ${
                                        props.productClicked.securitySymbol
                                      }`
                                    : `${t("assetInfo.receiveApproximate")} ${Number(
                                        Number(tradeAmount) *
                                          Number(currentPrice),
                                      )?.toFixed(6)} ${
                                        selectedCurrency.symbol
                                      } ${t("assetInfo.forCustom")} ${Number(tradeAmount)} ${
                                        props.productClicked.securitySymbol
                                      }`}
                                </p>
                              )}
                            {props.productClicked.poolType ===
                              PoolType.marginPool &&
                              Number(limitPrice) > 0 && (
                                <p
                                  style={{
                                    width: "100%",
                                    wordWrap: "break-word",
                                    color: "#4e2bd7",
                                  }}
                                  className="asset-info-popup-trading-first-header-text"
                                >
                                  {tradeType === "buy"
                                    ? `${t("assetInfo.payApproximate")} ${Number(
                                        Number(tradeAmount) *
                                          Number(
                                            Number(tradePrice) > 0
                                              ? tradePrice
                                              : limitPrice,
                                          ) *
                                          Number(props.productClicked?.margin),
                                      )?.toFixed(6)} ${
                                        selectedCurrency.symbol
                                      } ${t("assetInfo.forCustom")} ${Number(tradeAmount)} ${
                                        props.productClicked.securitySymbol
                                      } ${t("assetInfo.dueTo")} ${
                                        Number(props.productClicked?.margin) *
                                        100
                                      }% margin to open this long position`
                                    : `${t("assetInfo.payApproximate")} ${Number(
                                        Number(tradeAmount) *
                                          Number(
                                            Number(tradePrice) > 0
                                              ? tradePrice
                                              : limitPrice,
                                          ) *
                                          Number(props.productClicked?.margin),
                                      )?.toFixed(6)} ${
                                        selectedCurrency.symbol
                                      } ${t("assetInfo.forCustom")} ${Number(tradeAmount)} ${
                                        props.productClicked.securitySymbol
                                      } ${t("assetInfo.dueTo")} ${
                                        Number(props.productClicked?.margin) *
                                        100
                                      }% margin to open this short position`}
                                </p>
                              )}
                            {props.productClicked.poolType ===
                              PoolType.secondaryPool &&
                              Number(limitPrice) > 0 && (
                                <p
                                  style={{
                                    width: "100%",
                                    wordWrap: "break-word",
                                    color: "#4e2bd7",
                                  }}
                                  className="asset-info-popup-trading-first-header-text"
                                >
                                  {tradeType === "buy"
                                    ? `${t("assetInfo.payApproximate")} ${Number(
                                        Number(tradeAmount) /
                                          Number(
                                            Number(tradePrice) > 0
                                              ? tradePrice
                                              : limitPrice,
                                          ),
                                      )?.toFixed(6)} ${
                                        props.productClicked.securitySymbol
                                      } ${t("assetInfo.forCustom")} ${Number(tradeAmount)} ${
                                        selectedCurrency.symbol
                                      }`
                                    : `${t("assetInfo.receiveApproximate")} ${Number(
                                        Number(tradeAmount) *
                                          Number(
                                            Number(tradePrice) > 0
                                              ? tradePrice
                                              : limitPrice,
                                          ),
                                      )?.toFixed(6)} ${
                                        selectedCurrency.symbol
                                      } ${t("assetInfo.forCustom")} ${Number(tradeAmount)} ${
                                        props.productClicked.securitySymbol
                                      }`}
                                </p>
                              )}
                          </>
                        )}

                        {Object.keys(paraswapDetails).length > 0 && (
                          <>
                            <div className="asset-info-popup-trading-first-footer">
                              <div
                                style={{ minWidth: "fit-content" }}
                                className="asset-info-popup-trading-first-footer-body"
                              >
                                <img
                                  src={infoIcon}
                                  alt="Info Icon"
                                  className="asset-info-popup-trading-slippage-icon"
                                />
                                <p
                                  style={{ minWidth: "fit-content" }}
                                  className="asset-info-popup-trading-first-footer-text"
                                >
                                  Slippage
                                </p>
                              </div>
                              <div
                                style={{
                                  marginLeft: "5px",
                                }}
                                className="a-f-content-footer-input-container"
                              >
                                <div
                                  style={{
                                    minWidth: "fit-content",
                                    marginRight: "3px",
                                  }}
                                  onClickCapture={() => {
                                    setTrySwapAgain(false);
                                    setSwapSlippage(0.5);
                                  }}
                                  onClick={() => {
                                    setTrySwapAgain(true);
                                  }}
                                  className="a-f-content-footer-currencies-slip"
                                >
                                  <div className="a-f-content-footer-currencies-container">
                                    <p className="a-f-content-footer-currency">
                                      0.5 %
                                    </p>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    minWidth: "fit-content",
                                    marginRight: "3px",
                                  }}
                                  onClickCapture={() => {
                                    setTrySwapAgain(false);
                                    setSwapSlippage(1);
                                  }}
                                  onClick={() => {
                                    setTrySwapAgain(true);
                                  }}
                                  className="a-f-content-footer-currencies-slip"
                                >
                                  <div className="a-f-content-footer-currencies-container">
                                    <p className="a-f-content-footer-currency">
                                      1 %
                                    </p>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    minWidth: "fit-content",
                                  }}
                                  onClickCapture={() => {
                                    setTrySwapAgain(false);
                                    setSwapSlippage(5);
                                  }}
                                  onClick={() => {
                                    setTrySwapAgain(true);
                                  }}
                                  className="a-f-content-footer-currencies-slip"
                                >
                                  <div className="a-f-content-footer-currencies-container">
                                    <p className="a-f-content-footer-currency">
                                      5 %
                                    </p>
                                  </div>
                                </div>
                                <div className="a-f-content-footer-input-group">
                                  <input
                                    style={{
                                      border: " 1px solid #d8d9df",
                                      borderRadius: "8px",
                                    }}
                                    onInput={(e) => {
                                      setTrySwapAgain(false);
                                      setSwapSlippage(e.target.value);
                                    }}
                                    type="number"
                                    className="a-f-content-footer-input"
                                    placeholder="00.00"
                                    value={swapSlippage}
                                  />
                                </div>

                                {trySwapAgain && (
                                  <div
                                    style={{ background: "transparent" }}
                                    className="a-f-content-footer-currencies"
                                  >
                                    <div className="a-f-content-footer-currencies-container">
                                      <p className="a-f-content-footer-currency">
                                        %
                                      </p>
                                    </div>
                                  </div>
                                )}

                                {!trySwapAgain && (
                                  <div
                                    style={{
                                      marginLeft: "3px",
                                    }}
                                    onClick={() => {
                                      setTrySwapAgain(true);
                                    }}
                                    className="a-f-content-footer-currencies-slip"
                                  >
                                    <div className="a-f-content-footer-currencies-container">
                                      <p className="a-f-content-footer-currency">
                                        Retry
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="a-f-content-footer-input-container">
                              <div className="a-f-content-footer-input-group">
                                <input
                                  id="add-funds-popup-input"
                                  disabled={true}
                                  type="text"
                                  className="a-f-content-footer-input"
                                  placeholder="00.00"
                                  value={paraswapDetails?.amount?.toFixed(10)}
                                />
                              </div>
                              <div className="a-f-content-footer-currencies">
                                <div className="a-f-content-footer-currencies-container">
                                  <p className="a-f-content-footer-currency">
                                    {tradeType === "buy"
                                      ? props.productClicked.currencySymbol
                                      : selectedCurrency.symbol}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                      {props.productClicked.poolType === PoolType.marginPool &&
                        Number(tradeAmount) > 0 &&
                        Number(collateralAdded) <
                          Number(requiredCollateral) && (
                          <div className="asset-info-popup-trading-first-footer">
                            <div className="asset-info-popup-trading-first-footer-body">
                              <img
                                src={infoIcon}
                                alt="Info Icon"
                                className="asset-info-popup-trading-slippage-icon"
                              />
                              <p className="asset-info-popup-trading-first-footer-text">
                                {t(
                                  "assetInfo.orderRejectInsufficientCollateral",
                                )}
                              </p>
                            </div>
                          </div>
                        )}

                      {props.productClicked.poolType !==
                        PoolType.primaryPool && (
                        <div className="asset-info-popup-trading-first-header">
                          <div className="asset-info-popup-trading-first-header-text-container">
                            <p className="asset-info-popup-trading-first-header-text">
                              {t("assetInfo.price")}
                            </p>
                          </div>
                          <div className="asset-info-popup-trading-input-group">
                            <div className="asset-info-popup-trading-price-input-group">
                              <div
                                onClick={() => {
                                  if (tradeCategory === "limit") {
                                    if (isTradeInput) {
                                      setTradePrice(Number(tradePrice) + 1);
                                    } else if (Number(limitPrice) >= 0) {
                                      setLimitPrice(Number(limitPrice) + 1);
                                    }
                                  }
                                }}
                                style={
                                  tradeCategory === "market"
                                    ? { cursor: "unset" }
                                    : {}
                                }
                                className="asset-info-popup-trading-price-toggle"
                              >
                                <img
                                  src={increaseIcon}
                                  alt="Price Increase Icon"
                                />
                              </div>
                              <input
                                onInputCapture={() => {
                                  setIsTradeInput(true);
                                }}
                                onInput={(e) => {
                                  setTradePrice(e.target.value);
                                }}
                                disabled={
                                  tradeCategory === "market" ? true : false
                                }
                                type="number"
                                value={
                                  tradeCategory === "market"
                                    ? currentPrice
                                    : !isTradeInput
                                      ? limitPrice
                                      : tradePrice
                                }
                                className="asset-info-popup-trading-price-input"
                                placeholder={currentPrice}
                              />
                              <div
                                onClick={() => {
                                  if (tradeCategory === "limit") {
                                    if (
                                      isTradeInput &&
                                      Number(tradePrice) > 0
                                    ) {
                                      setTradePrice(Number(tradePrice) - 1);
                                    } else if (Number(limitPrice) > 0) {
                                      setLimitPrice(Number(limitPrice) - 1);
                                    }
                                  }
                                }}
                                style={
                                  tradeCategory === "market"
                                    ? { cursor: "unset" }
                                    : {}
                                }
                                className="asset-info-popup-trading-price-toggle"
                              >
                                <img
                                  src={decreaseIcon}
                                  alt="Price Decrease Icon"
                                />
                              </div>
                            </div>
                            <div className="asset-info-popup-trading-categories">
                              {tradeCategory === "market" && (
                                <div
                                  onClick={() => {
                                    setTradCategory("market");
                                    setRefereshDetails(!refereshDetails);
                                  }}
                                  className="asset-info-popup-trading-category-active"
                                >
                                  <p className="asset-info-popup-trading-category-text-active">
                                    Market
                                  </p>
                                </div>
                              )}
                              {tradeCategory !== "market" && (
                                <div
                                  onClick={() => {
                                    setTradCategory("market");
                                    setRefereshDetails(!refereshDetails);
                                  }}
                                  className="asset-info-popup-trading-category"
                                >
                                  <p className="asset-info-popup-trading-category-text">
                                    Market
                                  </p>
                                </div>
                              )}
                              {tradeCategory === "limit" && (
                                <div
                                  onClick={() => {
                                    setTradCategory("limit");
                                    setRefereshDetails(!refereshDetails);
                                  }}
                                  className="asset-info-popup-trading-category-active"
                                >
                                  <p className="asset-info-popup-trading-category-text-active">
                                    Limit
                                  </p>
                                </div>
                              )}
                              {tradeCategory !== "limit" && (
                                <div
                                  onClick={() => {
                                    setTradCategory("limit");
                                    setRefereshDetails(!refereshDetails);
                                  }}
                                  className="asset-info-popup-trading-category"
                                >
                                  <p className="asset-info-popup-trading-category-text">
                                    Limit
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="asset-info-popup-trading-first-footer">
                        {props.productClicked.poolType !==
                          PoolType.marginPool && (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div className="asset-info-popup-trading-first-footer-body">
                              <img
                                src={infoIcon}
                                alt="Info Icon"
                                className="asset-info-popup-trading-slippage-icon"
                              />
                              <p className="asset-info-popup-trading-first-footer-text">
                                {t("assetInfo.expectedSlippage")}
                              </p>
                            </div>
                            <p className="asset-info-popup-trading-first-footer-text">
                              {sorValue.slippage} %
                            </p>
                          </div>
                        )}
                        {props.productClicked.poolType ===
                          PoolType.marginPool &&
                          Number(tradeAmount) > 0 && (
                            <React.Fragment>
                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <div className="asset-info-popup-trading-first-footer-body">
                                  <img
                                    src={infoIcon}
                                    alt="Info Icon"
                                    className="asset-info-popup-trading-slippage-icon"
                                  />
                                  <p className="asset-info-popup-trading-first-footer-text">
                                    {/* {t("assetInfo.requiredCollaterals")} */}
                                    Order Size
                                  </p>
                                </div>
                                <p className="asset-info-popup-trading-first-footer-text">
                                  {(
                                    Number(tradeAmount) *
                                    Number(
                                      tradeCategory === "limit" &&
                                        Number(tradePrice) > 0
                                        ? tradePrice
                                        : tradeCategory === "limit" &&
                                            limitPrice
                                          ? limitPrice
                                          : Number(newPrice) > 0
                                            ? Number(newPrice)
                                            : props.productClicked.currentPrice,
                                    )
                                  )?.toFixed(4)}{" "}
                                  {props.productClicked?.currencyFiatSymbol}
                                </p>
                              </div>

                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <div className="asset-info-popup-trading-first-footer-body">
                                  <img
                                    src={infoIcon}
                                    alt="Info Icon"
                                    className="asset-info-popup-trading-slippage-icon"
                                  />
                                  <p className="asset-info-popup-trading-first-footer-text">
                                    {/* {t("assetInfo.requiredCollaterals")} */}
                                    Leverage
                                  </p>
                                </div>
                                <p className="asset-info-popup-trading-first-footer-text">
                                  {(
                                    100 /
                                    (Number(props.productClicked?.margin) * 100)
                                  )?.toFixed(0)}
                                  x
                                </p>
                              </div>
                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <div className="asset-info-popup-trading-first-footer-body">
                                  <img
                                    src={infoIcon}
                                    alt="Info Icon"
                                    className="asset-info-popup-trading-slippage-icon"
                                  />
                                  <p className="asset-info-popup-trading-first-footer-text">
                                    {/* {t("assetInfo.requiredCollaterals")} */}
                                    Margin Amount
                                  </p>
                                </div>
                                <p className="asset-info-popup-trading-first-footer-text">
                                  {(
                                    Number(tradeAmount) *
                                    Number(
                                      tradeCategory === "limit" &&
                                        Number(tradePrice) > 0
                                        ? tradePrice
                                        : tradeCategory === "limit" &&
                                            limitPrice
                                          ? limitPrice
                                          : Number(newPrice) > 0
                                            ? Number(newPrice)
                                            : props.productClicked.currentPrice,
                                    ) *
                                    Number(props.productClicked?.margin)
                                  )?.toFixed(4)}{" "}
                                  {props.productClicked?.currencyFiatSymbol}
                                </p>
                              </div>

                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <div className="asset-info-popup-trading-first-footer-body">
                                  <img
                                    src={infoIcon}
                                    alt="Info Icon"
                                    className="asset-info-popup-trading-slippage-icon"
                                  />
                                  <p className="asset-info-popup-trading-first-footer-text">
                                    {/* {t("assetInfo.requiredCollaterals")} */}
                                    Stoploss %
                                  </p>
                                </div>
                                <p className="asset-info-popup-trading-first-footer-text">
                                  {(
                                    Number(props.productClicked?.collateral) *
                                    100
                                  )?.toFixed(2)}
                                  %
                                </p>
                              </div>
                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <div className="asset-info-popup-trading-first-footer-body">
                                  <img
                                    src={infoIcon}
                                    alt="Info Icon"
                                    className="asset-info-popup-trading-slippage-icon"
                                  />
                                  <p className="asset-info-popup-trading-first-footer-text">
                                    {/* {t("assetInfo.requiredCollaterals")} */}
                                    Required Stoploss
                                  </p>
                                </div>
                                <p className="asset-info-popup-trading-first-footer-text">
                                  {(
                                    Number(tradeAmount) *
                                    Number(
                                      tradeCategory === "limit" &&
                                        Number(tradePrice) > 0
                                        ? tradePrice
                                        : tradeCategory === "limit" &&
                                            limitPrice
                                          ? limitPrice
                                          : Number(newPrice) > 0
                                            ? Number(newPrice)
                                            : props.productClicked.currentPrice,
                                      // Number(tradePrice) > 0
                                      //   ? tradePrice
                                      //   : limitPrice,
                                    ) *
                                    Number(props.productClicked?.collateral)
                                  )?.toFixed(4)}{" "}
                                  {props.productClicked?.currencyFiatSymbol}
                                </p>
                              </div>

                              {!marginCalculationLoading && (
                                <React.Fragment>
                                  <div
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div className="asset-info-popup-trading-first-footer-body">
                                      <img
                                        src={infoIcon}
                                        alt="Info Icon"
                                        className="asset-info-popup-trading-slippage-icon"
                                      />
                                      <p className="asset-info-popup-trading-first-footer-text">
                                        {/* {t("assetInfo.requiredCollaterals")} */}
                                        Order Fee
                                      </p>
                                    </div>
                                    <p className="asset-info-popup-trading-first-footer-text">
                                      {Number(marginFees?.trade)?.toFixed(4)}{" "}
                                      {props.productClicked?.currencyFiatSymbol}
                                    </p>
                                  </div>

                                  <div
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div className="asset-info-popup-trading-first-footer-body">
                                      <img
                                        src={infoIcon}
                                        alt="Info Icon"
                                        className="asset-info-popup-trading-slippage-icon"
                                      />
                                      <p className="asset-info-popup-trading-first-footer-text">
                                        {/* {t("assetInfo.requiredCollaterals")} */}
                                        Stoploss Fee
                                      </p>
                                    </div>
                                    <p className="asset-info-popup-trading-first-footer-text">
                                      {Number(marginFees?.stoploss)?.toFixed(4)}{" "}
                                      {props.productClicked?.currencyFiatSymbol}
                                    </p>
                                  </div>

                                  <div
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div className="asset-info-popup-trading-first-footer-body">
                                      <img
                                        src={infoIcon}
                                        alt="Info Icon"
                                        className="asset-info-popup-trading-slippage-icon"
                                      />
                                      <p className="asset-info-popup-trading-first-footer-text">
                                        {/* {t("assetInfo.requiredCollaterals")} */}
                                        Deposit Fee
                                      </p>
                                    </div>
                                    <p className="asset-info-popup-trading-first-footer-text">
                                      {Number(marginFees?.deposit)?.toFixed(4)}{" "}
                                      {props.productClicked?.currencyFiatSymbol}
                                    </p>
                                  </div>

                                  {tradeType === "buy" && (
                                    <div
                                      style={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div className="asset-info-popup-trading-first-footer-body">
                                        <img
                                          src={infoIcon}
                                          alt="Info Icon"
                                          className="asset-info-popup-trading-slippage-icon"
                                        />
                                        <p className="asset-info-popup-trading-first-footer-text">
                                          {/* {t("assetInfo.requiredCollaterals")} */}
                                          Required{" "}
                                          {
                                            props.productClicked
                                              ?.currencyFiatSymbol
                                          }{" "}
                                          Balance
                                        </p>
                                      </div>
                                      <p className="asset-info-popup-trading-first-footer-text">
                                        {(
                                          Number(
                                            props.productClicked?.swapFee,
                                          ) *
                                          (Number(tradeAmount) *
                                            Number(
                                              tradeCategory === "limit" &&
                                                Number(tradePrice) > 0
                                                ? tradePrice
                                                : tradeCategory === "limit" &&
                                                    limitPrice
                                                  ? limitPrice
                                                  : Number(newPrice) > 0
                                                    ? Number(newPrice)
                                                    : props.productClicked
                                                        .currentPrice,
                                              // Number(limitPrice) > 0
                                              //   ? limitPrice
                                              //   : Number(newPrice) > 0
                                              //     ? Number(newPrice)
                                              //     : tradePrice,
                                            ) *
                                            Number(
                                              props.productClicked?.margin,
                                            ))
                                        )?.toFixed(4)}{" "}
                                        USDC
                                      </p>
                                    </div>
                                  )}

                                  <div
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div className="asset-info-popup-trading-first-footer-body">
                                      <img
                                        src={infoIcon}
                                        alt="Info Icon"
                                        className="asset-info-popup-trading-slippage-icon"
                                      />
                                      <p className="asset-info-popup-trading-first-footer-text">
                                        {/* {t("assetInfo.requiredCollaterals")} */}
                                        Total Required
                                      </p>
                                    </div>
                                    <p className="asset-info-popup-trading-first-footer-text">
                                      {Number(requiredCollateral)?.toFixed(4)}{" "}
                                      {props.productClicked?.currencyFiatSymbol}
                                    </p>
                                  </div>
                                </React.Fragment>
                              )}
                            </React.Fragment>
                          )}
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="asset-info-popup-second">
                {!showAssetTrading && (
                  <>
                    {productDetails === "overview" && (
                      <p className="asset-info-popup-second-header-text">
                        {t("assetInfo.graphOverview")}
                      </p>
                    )}
                    {productDetails === "fundamentals" && (
                      <p className="asset-info-popup-second-header-text">
                        {t("assetInfo.companyProfile")}
                      </p>
                    )}
                    <div className="asset-info-popup-second-body">
                      {productDetails === "overview" && (
                        <>
                          <div className="asset-info-popup-second-body-header">
                            <div className="asset-info-popup-second-body-header-text-container">
                              {grahDetails === "price" && (
                                <button
                                  onClick={() => {
                                    setGrahDetails("price");
                                  }}
                                  className="asset-info-popup-second-body-header-button-active"
                                >
                                  <p className="asset-info-popup-second-body-header-button-text-active">
                                    {t("assetInfo.byPrice")}
                                  </p>
                                </button>
                              )}
                              {grahDetails !== "price" && (
                                <button
                                  onClick={() => {
                                    setGrahDetails("price");
                                  }}
                                  className="asset-info-popup-second-body-header-button"
                                >
                                  <p className="asset-info-popup-second-body-header-button-text">
                                    {t("assetInfo.byPrice")}
                                  </p>
                                </button>
                              )}
                              {grahDetails === "volume" && (
                                <button
                                  onClick={() => {
                                    setGrahDetails("volume");
                                  }}
                                  className="asset-info-popup-second-body-header-button-active"
                                >
                                  <p className="asset-info-popup-second-body-header-button-text-active">
                                    {t("assetInfo.byVolume")}
                                  </p>
                                </button>
                              )}
                              {grahDetails !== "volume" && (
                                <button
                                  onClick={() => {
                                    setGrahDetails("volume");
                                  }}
                                  className="asset-info-popup-second-body-header-button"
                                >
                                  <p className="asset-info-popup-second-body-header-button-text">
                                    {t("assetInfo.byVolume")}
                                  </p>
                                </button>
                              )}
                            </div>
                            <p className="asset-info-popup-second-body-header-text-footer">
                              P/A
                            </p>
                          </div>

                          <div className="asset-info-popup-highchart-container">
                            {!candleStickClicked && (
                              <>
                                {grahDetails === "price" &&
                                  chartData?.priceChartData && (
                                    <AreaChart
                                      areaData={chartData.priceChartData}
                                      candleStickData={{}}
                                      graphTime={graphTime.time}
                                      currencySymbol={
                                        props.productClicked?.currencyFiatSymbol
                                      }
                                      graphType={grahDetails}
                                      ismaximised={isMaximized}
                                    />
                                  )}
                                {grahDetails === "volume" &&
                                  chartData?.volumeChartData && (
                                    <AreaChart
                                      areaData={chartData?.volumeChartData}
                                      candleStickData={{}}
                                      graphTime={graphTime.time}
                                      currencySymbol={
                                        props.productClicked?.currencyFiatSymbol
                                      }
                                      graphType={grahDetails}
                                      ismaximised={isMaximized}
                                    />
                                  )}
                              </>
                            )}
                            {candleStickClicked && (
                              <>
                                {grahDetails === "price" &&
                                  chartData?.priceCandleStickData && (
                                    <CandleStickChart
                                      candleStickData={
                                        chartData?.priceCandleStickData
                                      }
                                      graphTime={graphTime.time}
                                      currencySymbol={
                                        props.productClicked?.currencyFiatSymbol
                                      }
                                      graphType={grahDetails}
                                      ismaximised={isMaximized}
                                    />
                                  )}
                                {grahDetails === "volume" &&
                                  chartData?.volumeCandleStickData && (
                                    <CandleStickChart
                                      candleStickData={
                                        chartData?.volumeCandleStickData
                                      }
                                      graphTime={graphTime.time}
                                      currencySymbol={
                                        props.productClicked?.currencyFiatSymbol
                                      }
                                      graphType={grahDetails}
                                      ismaximised={isMaximized}
                                    />
                                  )}
                              </>
                            )}
                            <div className="asset-info-popup-highchart-container-buttons">
                              {graphTime.label === "1h" && (
                                <button
                                  onClick={() => {
                                    setGraphTime({
                                      label: "1h",
                                      time: 60 * 60,
                                    });
                                  }}
                                  className="asset-info-popup-highchart-container-button-active"
                                >
                                  <p className="asset-info-popup-highchart-container-button-text-active">
                                    1H
                                  </p>
                                </button>
                              )}
                              {graphTime.label !== "1h" && (
                                <button
                                  onClick={() => {
                                    setGraphTime({
                                      label: "1h",
                                      time: 60 * 60,
                                    });
                                  }}
                                  className="asset-info-popup-highchart-container-button"
                                >
                                  <p className="asset-info-popup-highchart-container-button-text">
                                    1H
                                  </p>
                                </button>
                              )}

                              {graphTime.label === "24h" && (
                                <button
                                  onClick={() => {
                                    setGraphTime({
                                      label: "24h",
                                      time: 24 * 60 * 60,
                                    });
                                  }}
                                  className="asset-info-popup-highchart-container-button-active"
                                >
                                  <p className="asset-info-popup-highchart-container-button-text-active">
                                    24H
                                  </p>
                                </button>
                              )}

                              {graphTime.label !== "24h" && (
                                <button
                                  onClick={() => {
                                    setGraphTime({
                                      label: "24h",
                                      time: 24 * 60 * 60,
                                    });
                                  }}
                                  className="asset-info-popup-highchart-container-button"
                                >
                                  <p className="asset-info-popup-highchart-container-button-text">
                                    24H
                                  </p>
                                </button>
                              )}

                              {graphTime.label === "1w" && (
                                <button
                                  onClick={() => {
                                    setGraphTime({
                                      label: "1w",
                                      time: 7 * 24 * 60 * 60,
                                    });
                                  }}
                                  className="asset-info-popup-highchart-container-button-active"
                                >
                                  <p className="asset-info-popup-highchart-container-button-text-active">
                                    1W
                                  </p>
                                </button>
                              )}

                              {graphTime.label !== "1w" && (
                                <button
                                  onClick={() => {
                                    setGraphTime({
                                      label: "1w",
                                      time: 7 * 24 * 60 * 60,
                                    });
                                  }}
                                  className="asset-info-popup-highchart-container-button"
                                >
                                  <p className="asset-info-popup-highchart-container-button-text">
                                    1W
                                  </p>
                                </button>
                              )}

                              {graphTime.label === "1m" && (
                                <button
                                  onClick={() => {
                                    setGraphTime({
                                      label: "1m",
                                      time: 30 * 24 * 60 * 60,
                                    });
                                  }}
                                  className="asset-info-popup-highchart-container-button-active"
                                >
                                  <p className="asset-info-popup-highchart-container-button-text-active">
                                    1M
                                  </p>
                                </button>
                              )}

                              {graphTime.label !== "1m" && (
                                <button
                                  onClick={() => {
                                    setGraphTime({
                                      label: "1m",
                                      time: 30 * 24 * 60 * 60,
                                    });
                                  }}
                                  className="asset-info-popup-highchart-container-button"
                                >
                                  <p className="asset-info-popup-highchart-container-button-text">
                                    1M
                                  </p>
                                </button>
                              )}

                              {graphTime.label === "6m" && (
                                <button
                                  onClick={() => {
                                    setGraphTime({
                                      label: "6m",
                                      time: 6 * 30 * 24 * 60 * 60,
                                    });
                                  }}
                                  className="asset-info-popup-highchart-container-button-active"
                                >
                                  <p className="asset-info-popup-highchart-container-button-text-active">
                                    6M
                                  </p>
                                </button>
                              )}

                              {graphTime.label !== "6m" && (
                                <button
                                  onClick={() => {
                                    setGraphTime({
                                      label: "6m",
                                      time: 6 * 30 * 24 * 60 * 60,
                                    });
                                  }}
                                  className="asset-info-popup-highchart-container-button"
                                >
                                  <p className="asset-info-popup-highchart-container-button-text">
                                    6M
                                  </p>
                                </button>
                              )}

                              {graphTime.label === "1y" && (
                                <button
                                  onClick={() => {
                                    setGraphTime({
                                      label: "1y",
                                      time: 365 * 24 * 60 * 60,
                                    });
                                  }}
                                  className="asset-info-popup-highchart-container-button-active"
                                >
                                  <p className="asset-info-popup-highchart-container-button-text-active">
                                    1Y
                                  </p>
                                </button>
                              )}

                              {graphTime.label !== "1y" && (
                                <button
                                  onClick={() => {
                                    setGraphTime({
                                      label: "1y",
                                      time: 365 * 24 * 60 * 60,
                                    });
                                  }}
                                  className="asset-info-popup-highchart-container-button"
                                >
                                  <p className="asset-info-popup-highchart-container-button-text">
                                    1Y
                                  </p>
                                </button>
                              )}

                              {!candleStickClicked && (
                                <button
                                  onClick={() => {
                                    setCandleStickClicked(true);
                                  }}
                                  className="asset-info-popup-highchart-container-button"
                                >
                                  <img
                                    src={candleStickIcon}
                                    alt="Candle Stick Icon"
                                  />
                                </button>
                              )}
                              {candleStickClicked && (
                                <button
                                  onClick={() => {
                                    setCandleStickClicked(false);
                                  }}
                                  className="asset-info-popup-highchart-container-button"
                                >
                                  <img
                                    src={lineChartIcon}
                                    alt="Candle Stick Icon"
                                  />
                                </button>
                              )}
                            </div>
                          </div>

                          <div className="asset-info-popup-third">
                            {props.productClicked.poolType ===
                              PoolType.marginPool &&
                              props?.withdrawableRef?.length > 0 &&
                              Number(props?.totalWithdrawable) > 0 && (
                                <div className="asset-info-popup-collateral-container">
                                  <p className="asset-info-popup-collateral-header-text">
                                    {t("assetInfo.collateralDetails")}
                                  </p>
                                  <div className="asset-info-popup-collateral-body">
                                    <div className="asset-info-popup-collateral-main">
                                      <div className="asset-info-popup-collateral-main-first">
                                        <div className="asset-info-popup-collateral-main-first-header">
                                          <p className="asset-info-popup-collateral-main-title">
                                            {t("withdrawFunds.balance")}
                                          </p>
                                          <p className="asset-info-popup-collateral-main-first-text">
                                            {collateralAdded}{" "}
                                            {
                                              props.productClicked
                                                ?.currencyFiatSymbol
                                            }
                                          </p>
                                        </div>
                                        <div className="asset-info-popup-collateral-main-first-footer">
                                          <p className="asset-info-popup-collateral-main-title">
                                            Stoploss
                                          </p>
                                          <p className="asset-info-popup-collateral-main-second-footer">
                                            {Number(
                                              props.productClicked?.collateral,
                                            ) * 100}{" "}
                                            %
                                          </p>
                                        </div>
                                      </div>
                                      <div
                                        onClick={() => {
                                          setShowSetCollateralType("deposit");
                                          setShowSetCollateral(true);
                                          setShowSelectBank(false);
                                        }}
                                        className="asset-info-popup-collateral-main-second"
                                      >
                                        <div className="asset-info-popup-collateral-main-second-container">
                                          <img
                                            src={collateralBank}
                                            alt="Expand Icon"
                                          />
                                          <p className="asset-info-popup-collateral-main-second-text">
                                            {t("assetInfo.collateral")}
                                          </p>
                                        </div>
                                        <img
                                          src={collateralExpand}
                                          alt="Expand Icon"
                                        />
                                      </div>

                                      <div
                                        onClick={() => {
                                          setShowSetCollateralType("withdraw");
                                          setShowSetCollateral(true);
                                          setShowSelectBank(false);
                                        }}
                                        className="asset-info-popup-collateral-main-second"
                                      >
                                        <div className="asset-info-popup-collateral-main-second-container">
                                          <img
                                            src={collateralBankInactive}
                                            alt="Expand Icon"
                                          />

                                          <p className="asset-info-popup-collateral-main-second-text">
                                            {/* {t("assetInfo.collateral")} */}
                                            Withdraw Collateral
                                          </p>
                                        </div>
                                        <img
                                          src={collateralExpand}
                                          alt="Expand Icon"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            <div className="asset-info-popup-third-first">
                              <div className="asset-info-popup-third-first-container">
                                <div className="asset-info-popup-third-first-header">
                                  <p className="asset-info-popup-third-first-header-title">
                                    {t("assetInfo.marketStats")}
                                  </p>
                                </div>

                                <div className="asset-info-popup-third-first-body">
                                  <div className="asset-info-popup-third-first-body-cont">
                                    <div className="asset-info-popup-third-first-body-text-cont">
                                      <img src={volumeIcon} alt="" />
                                      <p className="asset-info-popup-third-first-body-text">
                                        {t("assetInfo.totalBought")}
                                      </p>
                                    </div>
                                    <p className="asset-info-popup-third-first-body-label">
                                      {formatNumberWithUnits(
                                        props.productClicked.totalBought,
                                      )}
                                    </p>
                                  </div>

                                  <div className="asset-info-popup-third-first-body-cont">
                                    <div className="asset-info-popup-third-first-body-text-cont">
                                      <img src={volumeIcon} alt="" />
                                      <p className="asset-info-popup-third-first-body-text">
                                        {t("assetInfo.totalSold")}
                                      </p>
                                    </div>
                                    <p className="asset-info-popup-third-first-body-label">
                                      {formatNumberWithUnits(
                                        props.productClicked.totalSold,
                                      )}
                                    </p>
                                  </div>

                                  <div className="asset-info-popup-third-first-body-cont">
                                    <div className="asset-info-popup-third-first-body-text-cont">
                                      <img src={volumeIcon} alt="" />
                                      <p className="asset-info-popup-third-first-body-text">
                                        {t("assetInfo.totalVolume")}
                                      </p>
                                    </div>
                                    <p className="asset-info-popup-third-first-body-label">
                                      {formatNumberWithUnits(
                                        Number(
                                          props.productClicked.totalBought,
                                        ) +
                                          Number(
                                            props.productClicked.totalSold,
                                          ),
                                      )}
                                    </p>
                                  </div>

                                  <div className="asset-info-popup-third-first-body-cont">
                                    <div className="asset-info-popup-third-first-body-text-cont">
                                      <img src={volumeIcon} alt="" />
                                      <p className="asset-info-popup-third-first-body-text">
                                        {t("assetInfo.totalBuyers")}
                                      </p>
                                    </div>
                                    <p className="asset-info-popup-third-first-body-label">
                                      {Number(
                                        props.productClicked?.totalBuyers,
                                      ) >= 1000
                                        ? formatNumberWithUnits(
                                            props.productClicked?.totalBuyers,
                                          )
                                        : props.productClicked?.totalBuyers}
                                    </p>
                                  </div>

                                  <div className="asset-info-popup-third-first-body-cont">
                                    <div className="asset-info-popup-third-first-body-text-cont">
                                      <img src={volumeIcon} alt="" />
                                      <p className="asset-info-popup-third-first-body-text">
                                        {t("assetInfo.totalSellers")}
                                      </p>
                                    </div>
                                    <p className="asset-info-popup-third-first-body-label">
                                      {Number(
                                        props.productClicked?.totalSellers,
                                      ) >= 1000
                                        ? formatNumberWithUnits(
                                            props.productClicked?.totalSellers,
                                          )
                                        : props.productClicked?.totalSellers}
                                    </p>
                                  </div>

                                  <div className="asset-info-popup-third-first-body-cont">
                                    <div className="asset-info-popup-third-first-body-text-cont">
                                      <img src={calenderIcon} alt="" />
                                      <p className="asset-info-popup-third-first-body-text">
                                        {t("assetInfo.launchedOn")}
                                      </p>
                                    </div>
                                    <p className="asset-info-popup-third-first-body-label">
                                      {props.productClicked?.createTimeFmt}
                                    </p>
                                  </div>

                                  <div className="asset-info-popup-third-first-body-cont">
                                    <div className="asset-info-popup-third-first-body-text-cont">
                                      <img src={categoryIcon} alt="" />
                                      <p className="asset-info-popup-third-first-body-text">
                                        {t("assetInfo.category")}
                                      </p>
                                    </div>
                                    <p className="asset-info-popup-third-first-body-label">
                                      {capitalizeFirstLetter(
                                        props.productClicked?.securityCategory,
                                      )}
                                    </p>
                                  </div>

                                  <div className="asset-info-popup-third-first-body-cont">
                                    <div className="asset-info-popup-third-first-body-text-cont">
                                      <img src={athIcon} alt="" />
                                      <p className="asset-info-popup-third-first-body-text">
                                        {t("assetInfo.allTimeHigh")}
                                      </p>
                                    </div>
                                    <p className="asset-info-popup-third-first-body-label">
                                      {props.productClicked?.highestPrice}{" "}
                                      {props.productClicked?.currencyFiatSymbol}{" "}
                                      ({" "}
                                      {props.productClicked?.prices.length > 0
                                        ? new Date(
                                            props.productClicked?.prices[
                                              props.productClicked?.pricesRawFmt?.indexOf(
                                                props.productClicked
                                                  ?.highestPrice,
                                              )
                                            ][0],
                                          ).toLocaleDateString()
                                        : new Date(
                                            Date.now(),
                                          ).toLocaleDateString()}{" "}
                                      ){" "}
                                    </p>
                                  </div>

                                  <div className="asset-info-popup-third-first-body-cont">
                                    <div className="asset-info-popup-third-first-body-text-cont">
                                      <img src={atlIcon} alt="" />
                                      <p className="asset-info-popup-third-first-body-text">
                                        {t("assetInfo.allTimeLow")}
                                      </p>
                                    </div>
                                    <p className="asset-info-popup-third-first-body-label">
                                      {props.productClicked?.lowestPrice}{" "}
                                      {props.productClicked?.currencyFiatSymbol}{" "}
                                      ({" "}
                                      {props.productClicked?.prices.length > 0
                                        ? new Date(
                                            props.productClicked?.prices[
                                              props.productClicked?.pricesRawFmt?.indexOf(
                                                props.productClicked
                                                  ?.lowestPrice,
                                              )
                                            ][0],
                                          ).toLocaleDateString()
                                        : new Date(
                                            Date.now(),
                                          ).toLocaleDateString()}{" "}
                                      ){" "}
                                    </p>
                                  </div>

                                  <div className="asset-info-popup-third-first-body-cont">
                                    <div className="asset-info-popup-third-first-body-text-cont">
                                      <img src={fixedFeeIcon} alt="" />
                                      <p className="asset-info-popup-third-first-body-text">
                                        {t("assetInfo.fixedSwapFee")}
                                      </p>
                                    </div>
                                    <p className="asset-info-popup-third-first-body-label">
                                      {props.productClicked?.issueingFee ||
                                        props.productClicked?.swapFee}{" "}
                                      %
                                    </p>
                                  </div>
                                </div>

                                {props?.productClicked?.offeringDocData
                                  ?.Business?.Summary && (
                                  <>
                                    <div className="asset-info-popup-third-first-body-line"></div>
                                    <p className="asset-info-popup-third-first-footer-text">
                                      {typeof props?.productClicked
                                        ?.offeringDocData?.Business?.Summary ===
                                      "string"
                                        ? props?.productClicked?.offeringDocData
                                            ?.Business?.Summary
                                        : ""}
                                    </p>
                                  </>
                                )}
                              </div>

                              {Number(props?.productClicked?.lowestPrice) !==
                                Number(props?.productClicked?.highestPrice) && (
                                <div className="asset-info-popup-third-first-footer-container">
                                  <p className="asset-info-popup-third-first-footer-title">
                                    Price Range
                                  </p>

                                  <div className="asset-info-popup-third-first-footer-body-cont">
                                    <div
                                      id="price-range-page-container"
                                      className="asset-info-popup-third-first-footer-body"
                                    >
                                      <div
                                        id="price-range-page"
                                        className="asset-info-popup-third-first-footer-body-pointer-cont"
                                      >
                                        <div className="asset-info-popup-third-first-footer-body-pointer">
                                          <p
                                            id="price-range-page-text"
                                            className="asset-info-popup-third-first-footer-body-pointer-text"
                                          ></p>
                                        </div>

                                        <img
                                          className="asset-info-popup-third-first-footer-body-pointer-img"
                                          src={priceIndIcon}
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                    <div className="asset-info-popup-third-first-footer-body-price-cont">
                                      <div
                                        id="price-range-line"
                                        onClick={(e) => {
                                          const rangeDiv =
                                            document.getElementById(
                                              "price-range-line",
                                            );
                                          const rangeRect =
                                            rangeDiv.getBoundingClientRect();
                                          const clickX =
                                            e.clientX - rangeRect.left;
                                          const price = Number(
                                            (
                                              (clickX / rangeDiv.offsetWidth) *
                                                (Number(
                                                  props?.productClicked
                                                    ?.highestPrice,
                                                ) -
                                                  Number(
                                                    props?.productClicked
                                                      ?.lowestPrice,
                                                  )) +
                                              Number(
                                                props?.productClicked
                                                  ?.lowestPrice,
                                              )
                                            ).toFixed(2),
                                          );
                                          updatePointerPosition(price);
                                        }}
                                        onLoad={() => {
                                          updatePointerPosition(
                                            Number(
                                              (
                                                Number(
                                                  props?.productClicked
                                                    ?.highestPrice,
                                                ) / 2
                                              ).toFixed(2),
                                            ),
                                            true,
                                          );
                                        }}
                                        className="asset-info-popup-third-first-footer-body-price-line"
                                      >
                                        <img
                                          id="price-range-line-dot"
                                          className="asset-info-popup-third-first-footer-body-price-ind"
                                          src={priceDotIcon}
                                          alt=""
                                        />
                                        <div className="asset-info-popup-third-first-footer-body-price-mark-start"></div>
                                        <div className="asset-info-popup-third-first-footer-body-price-mark-end"></div>
                                      </div>
                                    </div>

                                    <div className="asset-info-popup-third-first-footer-body-price-label">
                                      <div className="asset-info-popup-third-first-footer-body-price-low">
                                        <p className="asset-info-popup-third-first-footer-body-price-low-title">
                                          {t("assetInfo.fixedSwapFee")}
                                        </p>
                                        <p className="asset-info-popup-third-first-footer-body-price-low-text">
                                          {props?.productClicked?.allTimeLow}
                                        </p>
                                      </div>

                                      <div className="asset-info-popup-third-first-footer-body-price-high">
                                        <p className="asset-info-popup-third-first-footer-body-price-low-title">
                                          {t("assetInfo.allTimeHigh")}
                                        </p>
                                        <p className="asset-info-popup-third-first-footer-body-price-low-text">
                                          {props?.productClicked?.highestPrice}
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="asset-info-popup-third-first-footer-last">
                                    <img src={bulbIcon} alt="" />
                                    <p className="asset-info-popup-third-first-footer-last-text">
                                      {Number(
                                        newPrice ||
                                          props.productClicked.currentPrice,
                                      ) >=
                                      Number(
                                        props.productClicked
                                          .pricesBeforeTodayFmt
                                          ?.priceBeforeToday,
                                      )
                                        ? (
                                            ((Number(
                                              newPrice ||
                                                props.productClicked
                                                  .currentPrice,
                                            ) -
                                              Number(
                                                props.productClicked
                                                  .pricesBeforeTodayFmt
                                                  ?.priceBeforeToday,
                                              )) *
                                              100) /
                                            Number(
                                              newPrice ||
                                                props.productClicked
                                                  .currentPrice,
                                            )
                                          ).toFixed(2)
                                        : (
                                            ((Number(
                                              props.productClicked
                                                .pricesBeforeTodayFmt
                                                ?.priceBeforeToday,
                                            ) -
                                              Number(
                                                newPrice ||
                                                  props.productClicked
                                                    .currentPrice,
                                              )) *
                                              100) /
                                            Number(
                                              props.productClicked
                                                .pricesBeforeTodayFmt
                                                ?.priceBeforeToday,
                                            )
                                          ).toFixed(2)}{" "}
                                      {Number(
                                        newPrice ||
                                          props.productClicked.currentPrice,
                                      ) >=
                                      Number(
                                        props.productClicked
                                          .pricesBeforeTodayFmt
                                          ?.priceBeforeToday,
                                      )
                                        ? "Increase"
                                        : "Decrease"}{" "}
                                      in 24h.{" "}
                                      {/* <span className="asset-info-popup-third-first-footer-last-text-label">
                                   The current drop is due to shift in price
                                   actions
                                 </span> */}
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* leadership
                                    will make a strong comeback next quarter. */}

                            {/* <div className="asset-info-popup-third-second">
                            <div className="asset-info-popup-third-second-header">
                              <p className="asset-info-popup-third-first-header-title">
                                Dividends
                              </p>
                            </div>

                            <div className="asset-info-popup-third-second-body">
                              <div className="asset-info-popup-third-second-body-cont">
                                <div className="asset-info-popup-third-second-body-content">
                                  <img src={calenderBgIcon} alt="" />

                                  <div className="asset-info-popup-third-second-body-content-body">
                                    <div className="asset-info-popup-third-second-body-content-body-cont">
                                      <p className="asset-info-popup-third-second-body-content-body-text">
                                        Dividend Date
                                      </p>
                                    </div>

                                    <p className="asset-info-popup-third-second-body-content-label">
                                      May 31st, 2024
                                    </p>
                                  </div>
                                </div>

                                <div className="asset-info-popup-third-second-body-content">
                                  <img src={netDividendIcon} alt="" />

                                  <div className="asset-info-popup-third-second-body-content-body">
                                    <div className="asset-info-popup-third-second-body-content-body-cont">
                                      <p className="asset-info-popup-third-second-body-content-body-text">
                                        Next Dividend
                                      </p>
                                    </div>

                                    <p className="asset-info-popup-third-second-body-content-label">
                                      $ 1.24
                                    </p>
                                  </div>
                                </div>

                                <div className="asset-info-popup-third-second-body-content">
                                  <img src={dividendYieldIcon} alt="" />

                                  <div className="asset-info-popup-third-second-body-content-body">
                                    <div className="asset-info-popup-third-second-body-content-body-cont">
                                      <p className="asset-info-popup-third-second-body-content-body-text">
                                        Dividend Yield TTM
                                      </p>
                                    </div>

                                    <p className="asset-info-popup-third-second-body-content-label">
                                      0.72 %
                                    </p>
                                  </div>
                                </div>

                                <div className="asset-info-popup-third-second-body-content">
                                  <img src={payoutIcon} alt="" />

                                  <div className="asset-info-popup-third-second-body-content-body">
                                    <div className="asset-info-popup-third-second-body-content-body-cont">
                                      <p className="asset-info-popup-third-second-body-content-body-text">
                                        Payout Ratio
                                      </p>
                                    </div>

                                    <p className="asset-info-popup-third-second-body-content-label">
                                      15.06%
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> */}

                            <div className="asset-info-popup-third-last">
                              <p className="asset-info-popup-third-first-header-title">
                                Links
                              </p>

                              <div className="asset-info-popup-third-last-content-outer">
                                {props?.productClicked?.offeringDocData
                                  ?.links && (
                                  <div className="asset-info-popup-third-last-content">
                                    <div className="asset-info-popup-third-last-content-text-cont">
                                      <p className="asset-info-popup-third-last-content-text">
                                        Link to Website
                                      </p>
                                    </div>

                                    <img src={expandForwardIcon} alt="" />
                                  </div>
                                )}
                                <div
                                  onClick={() => {
                                    window.open(
                                      chainId > 0
                                        ? `${ChainConfig[chainId]?.blockExplorerUrls[0]}address/${props?.productClicked?.security}`
                                        : `${
                                            ChainConfig[
                                              chainDetails[chainId]?.chainId
                                            ]?.blockExplorerUrls[0]
                                          }address/${
                                            props?.productClicked?.security
                                          }`,
                                      "_blank",
                                    );
                                  }}
                                  className="asset-info-popup-third-last-content"
                                >
                                  <div className="asset-info-popup-third-last-content-text-cont">
                                    <p className="asset-info-popup-third-last-content-text">
                                      Token{" "}
                                      {props?.productClicked?.securitySymbol}
                                    </p>
                                  </div>

                                  <img src={expandForwardIcon} alt="" />
                                </div>

                                <div
                                  onClick={() => {
                                    window.open(
                                      `${
                                        window.location.origin
                                      }/investments/assets/${
                                        props?.productClicked?.id
                                      }?chainId=${
                                        chainId > 0
                                          ? chainId
                                          : chainDetails[0]?.chainId
                                      }`,
                                      "_blank",
                                    );
                                  }}
                                  className="asset-info-popup-third-last-content"
                                >
                                  <div className="asset-info-popup-third-last-content-text-cont">
                                    <p className="asset-info-popup-third-last-content-text">
                                      Verified Asset Link
                                    </p>
                                  </div>

                                  <img src={expandForwardIcon} alt="" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {productDetails === "fundamentals" && (
                        <>
                          <div className="asset-info-popup-second-body-description-container">
                            <div>
                              <p className="asset-info-popup-second-body-description-text-header">
                                {t("assetInfo.businessSummary")}:
                              </p>
                              {props?.productClicked?.offeringDocData && (
                                <>
                                  <p
                                    className="asset-info-popup-second-body-description-text"
                                    id="asset-info-popup-business-summary"
                                  >
                                    <>
                                      {typeof props?.productClicked
                                        ?.offeringDocData?.Business?.Summary ===
                                      "string"
                                        ? props?.productClicked?.offeringDocData
                                            ?.Business?.Summary
                                        : ""}

                                      {Object.keys(
                                        props?.productClicked?.offeringDocData
                                          ?.Business || {},
                                      ).map((key) => (
                                        <>
                                          {String(key) !== "Summary" &&
                                            String(key) !== "Logo" &&
                                            String(key) !== "Icon" && (
                                              <>
                                                <p
                                                  style={{ marginTop: "5px" }}
                                                  className="asset-info-popup-second-body-description-text-header"
                                                >
                                                  {key}:
                                                </p>
                                                {typeof props?.productClicked
                                                  ?.offeringDocData?.Business[
                                                  String(key)
                                                ] === "object" && (
                                                  <>
                                                    {Object.keys(
                                                      props?.productClicked
                                                        ?.offeringDocData
                                                        ?.Business[
                                                        String(key) || {}
                                                      ],
                                                    ).map((_key) => (
                                                      <p className="asset-info-popup-second-body-description-text">
                                                        <b>{_key}</b>:{" "}
                                                        {typeof props
                                                          ?.productClicked
                                                          ?.offeringDocData
                                                          ?.Business[
                                                          String(key)
                                                        ][String(_key)] ===
                                                          "string" &&
                                                          props?.productClicked
                                                            ?.offeringDocData
                                                            ?.Business[
                                                            String(key)
                                                          ][String(_key)]}
                                                      </p>
                                                    ))}
                                                  </>
                                                )}
                                              </>
                                            )}
                                        </>
                                      ))}
                                    </>
                                    {props?.productClicked?.offeringDocData[
                                      "Offering docs urls"
                                    ] && (
                                      <p
                                        style={{ marginTop: "5px" }}
                                        className="asset-info-popup-second-body-description-text-header"
                                      >
                                        {t("assetInfo.offeringDocuments")}:
                                      </p>
                                    )}

                                    <p className="asset-info-popup-second-body-description-link">
                                      {props?.productClicked?.offeringDocData[
                                        "Offering docs urls"
                                      ]?.map((url) => (
                                        <a
                                          href={url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="asset-info-popup-second-body-description-text-link"
                                        >
                                          {" "}
                                          {url}
                                        </a>
                                      ))}
                                    </p>
                                  </p>
                                  {businessTag &&
                                    businessTag.scrollHeight >
                                      businessTag.clientHeight && (
                                      <p
                                        onClick={() => {
                                          if (
                                            businessTag.className ===
                                            "asset-info-popup-second-body-description-text-full"
                                          ) {
                                            businessTag.className =
                                              "asset-info-popup-second-body-description-text";
                                            setBusinessViewMoreClicked(false);
                                          } else {
                                            businessTag.className =
                                              "asset-info-popup-second-body-description-text-full";
                                            setBusinessViewMoreClicked(true);
                                          }
                                        }}
                                        className="asset-info-popup-second-body-description-link"
                                      >
                                        ...
                                        <span className="asset-info-popup-second-body-description-text-link">
                                          {" "}
                                          {!businessViewMoreClicked
                                            ? "View More."
                                            : "View Less."}
                                        </span>
                                      </p>
                                    )}
                                </>
                              )}
                            </div>
                          </div>

                          <div
                            id="asset-info-popup-second-body-description-container-financial"
                            className="asset-info-popup-second-body-description-container"
                          >
                            <div>
                              <p className="asset-info-popup-second-body-description-text-header">
                                {t("assetInfo.financialSummary")}:
                              </p>
                              {props.productClicked?.offeringDocData && (
                                <>
                                  {typeof props.productClicked?.offeringDocData
                                    ?.Financial?.Summary === "string" && (
                                    <p
                                      className="asset-info-popup-second-body-description-text"
                                      id="asset-info-popup-financial-summary"
                                    >
                                      {
                                        props.productClicked?.offeringDocData
                                          ?.Financial?.Summary
                                      }
                                    </p>
                                  )}
                                  {typeof props.productClicked?.offeringDocData
                                    ?.Financial?.Summary === "object" && (
                                    <>
                                      {Object.keys(
                                        props.productClicked?.offeringDocData
                                          ?.Financial?.Summary || {},
                                      ).map((key) => (
                                        <>
                                          <p
                                            className="asset-info-popup-second-body-description-text"
                                            id="asset-info-popup-financial-summary"
                                          >
                                            <b>{key}:</b>
                                            {typeof props.productClicked
                                              ?.offeringDocData?.Financial
                                              ?.Summary[String(key)] ===
                                              "object" &&
                                              Object.keys(
                                                props.productClicked
                                                  ?.offeringDocData?.Financial
                                                  ?.Summary[String(key)] || {},
                                              ).map((_key) => (
                                                <>
                                                  {String(_key) !== "items" && (
                                                    <p
                                                      className="asset-info-popup-second-body-description-text"
                                                      id="asset-info-popup-financial-summary"
                                                    >
                                                      <b>
                                                        {capitalizeFirstLetter(
                                                          String(_key),
                                                        )}
                                                        :{" "}
                                                        {typeof props
                                                          .productClicked
                                                          ?.offeringDocData
                                                          ?.Financial?.Summary[
                                                          String(key)
                                                        ][String(_key)] ===
                                                        "string"
                                                          ? props.productClicked
                                                              ?.offeringDocData
                                                              ?.Financial
                                                              ?.Summary[
                                                              String(key)
                                                            ][String(_key)]
                                                          : ""}
                                                      </b>
                                                    </p>
                                                  )}

                                                  {String(_key) === "items" && (
                                                    <>
                                                      {props.productClicked?.offeringDocData?.Financial?.Summary[
                                                        String(key)
                                                      ][String(_key)].map(
                                                        (obj) => (
                                                          <table
                                                            style={{
                                                              width: "100%",
                                                              textAlign:
                                                                "center",
                                                              borderCollapse:
                                                                "collapse",
                                                              marginBottom:
                                                                "2px",
                                                            }}
                                                          >
                                                            <thead>
                                                              <tr>
                                                                {Object.keys(
                                                                  obj || {},
                                                                ).map((key) => (
                                                                  <th
                                                                    style={{
                                                                      whiteSpace:
                                                                        "normal",
                                                                      wordWrap:
                                                                        "break-word",
                                                                      border:
                                                                        "1px solid",
                                                                    }}
                                                                  >
                                                                    {key}
                                                                  </th>
                                                                ))}
                                                              </tr>
                                                            </thead>
                                                            <tbody>
                                                              <tr>
                                                                {Object.values(
                                                                  obj || {},
                                                                ).map((val) => (
                                                                  <td
                                                                    style={{
                                                                      whiteSpace:
                                                                        "normal",
                                                                      wordWrap:
                                                                        "break-word",
                                                                      border:
                                                                        "1px solid",
                                                                    }}
                                                                  >
                                                                    {val}
                                                                  </td>
                                                                ))}
                                                              </tr>
                                                            </tbody>
                                                          </table>
                                                        ),
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              ))}
                                          </p>
                                        </>
                                      ))}
                                    </>
                                  )}

                                  {!financialViewMoreClicked &&
                                    financialTag &&
                                    financialTag.scrollHeight >
                                      financialTag.clientHeight && (
                                      <p
                                        onClick={() => {
                                          if (
                                            financialTag.className ===
                                            "asset-info-popup-second-body-description-text-full"
                                          ) {
                                            financialTag.className =
                                              "asset-info-popup-second-body-description-text";
                                            setFinancialViewMoreClicked(false);
                                          } else {
                                            financialTag.className =
                                              "asset-info-popup-second-body-description-text-full";
                                            setFinancialViewMoreClicked(true);
                                          }
                                        }}
                                        className="asset-info-popup-second-body-description-link"
                                      >
                                        ...
                                        <span className="asset-info-popup-second-body-description-text-link">
                                          {" "}
                                          {!financialViewMoreClicked
                                            ? "View More."
                                            : "View Less."}
                                        </span>
                                      </p>
                                    )}
                                </>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}
                {showAssetTrading &&
                  tradeType === "buy" &&
                  Number(userBalances.currency) < Number(tradeAmount) &&
                  props.productClicked.currencySymbol.startsWith("VC") && (
                    <>
                      <p className="asset-info-popup-second-trading-header-text">
                        Select a mode of payment
                      </p>
                      <div
                        id="asset-info-popup-pay-with-bank-account"
                        className="asset-info-popup-second-trading-body"
                      >
                        <div className="asset-info-popup-second-trading-body-header">
                          <div className="asset-info-popup-second-trading-body-icon-first">
                            <img
                              src={bankAccountIcon}
                              alt="Wallet Icon"
                              className="asset-info-popup-trading-info-icon"
                            />
                          </div>

                          <p className="asset-info-popup-second-trading-body-text">
                            Pay with Card/Bank Account
                          </p>
                          <div className="asset-info-popup-second-trading-body-icon-second">
                            <img
                              onClick={(e) => {
                                e.target.src.split("/")[
                                  e.target.src.split("/").length - 1
                                ] ===
                                radioButtonIcon.split("/")[
                                  radioButtonIcon.split("/").length - 1
                                ]
                                  ? (e.target.src = radioButtonClickedIcon)
                                  : (e.target.src = radioButtonIcon);
                                const frame = document.getElementById(
                                  "asset-info-popup-pay-with-bank-account",
                                );

                                if (
                                  frame &&
                                  frame.style.border !==
                                    "1.5px solid rgb(65, 115, 47)"
                                ) {
                                  frame.style.border =
                                    "1.5px solid rgb(65, 115, 47)";
                                  setPayWithBank(true);
                                } else if (frame) {
                                  frame.style.border = "1px solid #EEEEF0";
                                  setPayWithBank(false);
                                }
                              }}
                              src={radioButtonIcon}
                              alt="Radio Icon"
                              className="asset-info-popup-trading-info-icon"
                            />
                          </div>
                        </div>
                        <div className="asset-info-popup-second-trading-body-line"></div>
                        <div className="asset-info-popup-second-trading-body-fotter"></div>
                      </div>
                    </>
                  )}
              </div>
            </div>
          )}

          {showSetCollateral && showSelectBank && (
            <div className="asset-info-popup-body">
              <div className="asset-info-popup-first">
                <div className="asset-info-popup-collateral-container">
                  {showCustodyAccounts ? (
                    <p className="asset-info-popup-collateral-header-text-title">
                      {tradeAmount} {props?.productClicked?.securitySymbol} will
                      be transfered {tradeType === "buy" ? "to" : "from"} any of
                      these account after settlement.
                    </p>
                  ) : (
                    <p className="asset-info-popup-collateral-header-text-title">
                      Select Custody Bank to receive asset
                    </p>
                  )}
                  {!showCustodyAccounts && (
                    <div className="asset-info-popup-second">
                      {["ch", ""]?.includes(
                        props.productClicked?.custodyProvider?.toLowerCase(),
                      ) && (
                        <React.Fragment>
                          {bankList?.map((bnk, idx) => (
                            <div
                              onClick={() => {
                                setSelectedBankIdx(idx);
                                setSelectedBank({
                                  name: bnk?.companyName,
                                  id: bnk?.providerId,
                                  logo: bnk?.logo || bnk?.icon,
                                });
                              }}
                              className="select-bank-popup-body-content"
                            >
                              <div className="select-bank-popup-body-content-container">
                                <div className="select-bank-popup-body-content-icon">
                                  <img
                                    src={bnk?.logo || bnk?.icon}
                                    alt="Bank Logo"
                                  />
                                </div>

                                <div className="select-bank-popup-body-content-main">
                                  <div className="select-bank-popup-body-content-text-container">
                                    <p className="select-bank-popup-body-content-text">
                                      {bnk?.companyName}
                                    </p>
                                    <p className="select-bank-popup-body-content-label">
                                      {bnk?.productName?.startsWith(
                                        "Product Name",
                                      )
                                        ? bnk?.companyNameAbbreviation
                                        : bnk?.productName}
                                    </p>
                                  </div>
                                  {selectedBankIdx !== idx && (
                                    <img
                                      src={radioButtonIcon}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                  {selectedBankIdx === idx && (
                                    <img
                                      src={radioButtonClickedIcon}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </React.Fragment>
                      )}

                      {props.productClicked?.custodyProvider?.toLowerCase() ===
                        "br" && (
                        <React.Fragment>
                          {bankListBr?.map((bnk, idx) => (
                            <div
                              onClick={() => {
                                setSelectedBankIdx(idx);
                                setSelectedBank({
                                  name: bnk?.tradeName,
                                  id: bnk?.id,
                                  logo: bnk?.avatar,
                                  isBr: true,
                                });
                              }}
                              className="select-bank-popup-body-content"
                            >
                              <div className="select-bank-popup-body-content-container">
                                <div className="select-bank-popup-body-content-icon">
                                  <img src={bnk?.avatar} alt="Bank Logo" />
                                </div>

                                <div className="select-bank-popup-body-content-main">
                                  <div className="select-bank-popup-body-content-text-container">
                                    <p className="select-bank-popup-body-content-text">
                                      {bnk?.tradeName}
                                    </p>
                                    <p className="select-bank-popup-body-content-label">
                                      ISPB: {bnk?.ispb}
                                    </p>
                                  </div>
                                  {selectedBankIdx !== idx && (
                                    <img
                                      src={radioButtonIcon}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                  {selectedBankIdx === idx && (
                                    <img
                                      src={radioButtonClickedIcon}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </React.Fragment>
                      )}
                    </div>
                  )}
                  {showCustodyAccounts && (
                    <div className="asset-info-popup-second">
                      {["ch", ""]?.includes(
                        props.productClicked?.custodyProvider?.toLowerCase(),
                      ) && (
                        <React.Fragment>
                          {bankList?.map((bnk, idx) => (
                            <div className="select-bank-popup-body-content">
                              <div className="select-bank-popup-body-content-container">
                                <div className="select-bank-popup-body-content-icon">
                                  {bnk?.iconUrl && (
                                    <img src={bnk?.iconUrl} alt="Bank Logo" />
                                  )}
                                  {!bnk?.iconUrl && (
                                    <Avatar name={bnk.accountOwner} />
                                  )}
                                </div>

                                <div className="select-bank-popup-body-content-main">
                                  <div className="select-bank-popup-body-content-text-container">
                                    <p className="select-bank-popup-body-content-text">
                                      {bnk.accountOwner}
                                    </p>
                                    <p className="select-bank-popup-body-content-label">
                                      {bnk.account?.type}-
                                      {bnk.account?.identification}
                                    </p>
                                  </div>
                                  <img
                                    src={radioButtonClickedIcon}
                                    alt="Checkbox Icon"
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </React.Fragment>
                      )}

                      {props.productClicked?.custodyProvider?.toLowerCase() ===
                        "br" && (
                        <React.Fragment>
                          {bankListBr?.map((bnk, idx) => (
                            <div className="select-bank-popup-body-content">
                              <div className="select-bank-popup-body-content-container">
                                <div className="select-bank-popup-body-content-icon">
                                  {!bnk?.iconUrl && (
                                    <Avatar name={bnk.brandName} />
                                  )}
                                  {bnk?.iconUrl && (
                                    <img src={bnk?.iconUrl} alt="Bank Logo" />
                                  )}
                                </div>

                                <div className="select-bank-popup-body-content-main">
                                  <div className="select-bank-popup-body-content-text-container">
                                    <p className="select-bank-popup-body-content-text">
                                      {bnk?.brandName}
                                    </p>
                                    <p className="select-bank-popup-body-content-label">
                                      {bnk.type}-{bnk.number}
                                    </p>
                                  </div>
                                  <img
                                    src={radioButtonClickedIcon}
                                    alt="Checkbox Icon"
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </React.Fragment>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <div className="asset-info-popup-second"></div>
            </div>
          )}

          {showSetCollateral && !showSelectBank && !showUnderlyingAsset && (
            <div className="asset-info-popup-body">
              <div className="asset-info-popup-first">
                <div className="asset-info-popup-collateral-container">
                  <p className="asset-info-popup-collateral-header-text-title">
                    {t("assetInfo.selectInvestmentAsCollateral")}
                  </p>
                  <div className="asset-info-popup-second">
                    <div className="asset-info-popup-second-trading-body">
                      <div className="asset-info-popup-second-trading-body-line"></div>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <p className="add-funds-content-footer-text">
                          {t("assetInfo.enterCollateralAmount")}
                        </p>
                        <div
                          style={{
                            marginBottom: "0",
                          }}
                          className="add-funds-content-footer-balance-container"
                        >
                          {showSetCollateralType === "deposit" && (
                            <p className="add-funds-content-footer-balance-first">
                              {t("withdrawFunds.balance")}
                            </p>
                          )}
                          {showSetCollateralType === "withdraw" && (
                            <p className="add-funds-content-footer-balance-first">
                              Balance:{" "}
                              {Number(collateralAdded) > 0
                                ? Number(collateralAdded)?.toFixed(4)
                                : "0.0000"}
                            </p>
                          )}
                          {showSetCollateralType === "deposit" && (
                            <p
                              style={{
                                maxWidth: "100px",
                                wordWrap: "break-word",
                              }}
                              className="add-funds-content-footer-balance-second"
                            >
                              {Number(userBalances?.currency) > 0
                                ? Number(userBalances?.currency)?.toFixed(4)
                                : "0.0000"}
                            </p>
                          )}
                          {showSetCollateralType === "withdraw" && (
                            <p className="add-funds-content-footer-balance-first">
                              Withdrawable:{" "}
                              {Number(props?.totalWithdrawable)?.toFixed(6)}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="a-f-content-footer-input-container">
                        <div className="a-f-content-footer-input-group">
                          <p className="a-f-content-footer-input-text">
                            {
                              currenciesToSymbol[
                                currenciesToFiat[
                                  props.productClicked.currencySymbol
                                    ?.toLowerCase()
                                    ?.startsWith("vc")
                                    ? props.productClicked.currencySymbol
                                        ?.toLowerCase()
                                        ?.replace("vc", "")
                                        ?.toUpperCase()
                                    : props.productClicked.currencySymbol?.toUpperCase()
                                ]
                              ]
                            }
                          </p>
                          <input
                            id="add-funds-popup-input"
                            type="number"
                            className="a-f-content-footer-input"
                            placeholder="00.00"
                            onInput={(e) => {
                              setCollateralAmount(e.target.value);
                            }}
                          />
                        </div>
                        <div className="a-f-content-footer-currencies">
                          <div className="a-f-content-footer-currencies-container">
                            <p className="a-f-content-footer-currency">
                              {props.productClicked.currencySymbol}
                            </p>
                            <img alt="Exand Icon" src={exandIcon} />
                          </div>
                        </div>
                      </div>

                      <div className="asset-info-popup-second-trading-body-fotter"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="asset-info-popup-second"></div>
            </div>
          )}

          {showSetCollateral && showUnderlyingAsset && (
            <div className="asset-info-popup-body">
              <div className="asset-info-popup-first">
                <div className="asset-info-popup-collateral-container">
                  <p className="asset-info-popup-collateral-header-text-title">
                    {t("addFunds.underlyingAsset")}:
                  </p>
                  <div className="asset-info-popup-second">
                    <div className="select-bank-popup-body-content">
                      <div className="select-bank-popup-body-content-container">
                        <div
                          className="select-bank-popup-body-content-icon"
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                            overflow: "hidden",
                          }}
                        >
                          {underlyingAssetDt?.logo && (
                            <img
                              src={underlyingAssetDt?.logo}
                              alt="Bank Logo"
                            />
                          )}
                          {!underlyingAssetDt?.logo && (
                            <Avatar
                              name={
                                underlyingAssetDt?.tickerId ||
                                props.productClicked?.underlyingAsset?.tickerId
                              }
                            />
                          )}
                        </div>

                        <div className="select-bank-popup-body-content-main">
                          <div className="select-bank-popup-body-content-text-container">
                            <p className="select-bank-popup-body-content-text">
                              {underlyingAssetDt?.shortName ||
                                props.productClicked?.underlyingAsset
                                  ?.shortName}
                            </p>
                            <p className="select-bank-popup-body-content-label">
                              {underlyingAssetDt?.tickerId ||
                                props.productClicked?.underlyingAsset?.tickerId}
                            </p>
                          </div>
                          <div
                            style={{ minWidth: "30%" }}
                            className="select-bank-popup-body-content-text-container"
                          >
                            <p className="select-bank-popup-body-content-text">
                              {t("addFunds.price")}:{" "}
                            </p>
                            <p className="select-bank-popup-body-content-label">
                              {underlyingAssetDt?.price ||
                                props.productClicked?.underlyingAsset
                                  ?.price}{" "}
                              {underlyingAssetDt?.priceCurrencyId ||
                                props.productClicked?.underlyingAsset
                                  ?.priceCurrencyId}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="asset-info-popup-second-trading-body-line"></div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <p className="add-funds-content-footer-text">
                      {t("addFunds.exchange")}:{" "}
                      {underlyingAssetDt?.sourceId ||
                        props.productClicked?.underlyingAsset?.sourceId}
                    </p>
                    <div
                      style={{
                        marginBottom: "0",
                        minWidth: "50%",
                      }}
                      className="add-funds-content-footer-balance-container"
                    >
                      <p className="add-funds-content-footer-balance-first">
                        QTY:{" "}
                        {props.productClicked.poolType !== PoolType.primaryPool
                          ? (
                              Number(tradeAmount) /
                              Number(
                                underlyingAssetDt?.price ||
                                  props.productClicked?.underlyingAsset?.price,
                              )
                            )?.toFixed(2)
                          : tradeAmount}
                      </p>
                      <p
                        style={{ maxWidth: "100px", wordWrap: "break-word" }}
                        className="add-funds-content-footer-balance-second"
                      >
                        (
                        {props.productClicked.poolType !== PoolType.primaryPool
                          ? Number(tradeAmount)?.toFixed(2)
                          : (
                              Number(tradeAmount) *
                              Number(
                                underlyingAssetDt?.price ||
                                  props.productClicked?.underlyingAsset?.price,
                              )
                            ).toFixed(2)}{" "}
                        {underlyingAssetDt?.priceCurrencyId ||
                          props.productClicked?.underlyingAsset
                            ?.priceCurrencyId}
                        )
                      </p>
                    </div>
                  </div>
                  <div className="asset-info-popup-second-trading-body-line"></div>
                  <p className="asset-info-popup-collateral-header-text-title">
                    {t("addFunds.customerAccount")}
                  </p>
                  <div className="asset-info-popup-second">
                    <div className="select-bank-popup-body-content">
                      {userCustomerAccount?.cashAccountNumber !== "" && (
                        <div className="select-bank-popup-body-content-container">
                          <div
                            style={{
                              justifyContent: "center",
                              alignItems: "center",
                              overflow: "hidden",
                            }}
                            className="select-bank-popup-body-content-icon"
                          >
                            <Avatar
                              name={userCustomerAccount?.cashAccountNumber}
                            />
                          </div>

                          <div className="select-bank-popup-body-content-main">
                            <div className="select-bank-popup-body-content-text-container">
                              <p className="select-bank-popup-body-content-text">
                                Id: {userCustomerAccount?.cashAccountNumber}
                              </p>
                              <p className="select-bank-popup-body-content-label">
                                {t("addFunds.typeCash")}
                              </p>
                            </div>
                            <div className="select-bank-popup-body-content-text-container">
                              <p className="select-bank-popup-body-content-text">
                                {t("withdrawFunds.balance")}:
                              </p>
                              <p className="select-bank-popup-body-content-label">
                                {userCustomerAccount?.balance}{" "}
                                {userCustomerAccount?.currency}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                      {userCustomerAccount?.cashAccountNumber === "" && (
                        <div
                          style={{ flexDirection: "column" }}
                          className="select-bank-popup-body-content-container"
                        >
                          <p className="select-bank-popup-body-content-label">
                            You have no customer account associated with your
                            wallet, create new customer account to{" "}
                            {capitalizeFirstLetter(tradeType)} this asset.
                          </p>
                          <p className="select-bank-popup-body-content-text">
                            Account creation Details:
                          </p>

                          <div
                            style={{ width: "100%", alignItems: "center" }}
                            className="select-bank-popup-body-content-text-container"
                          >
                            <p className="select-bank-popup-body-content-text">
                              First Name:
                            </p>
                            <p className="select-bank-popup-body-content-label">
                              {userFirstName}
                            </p>
                          </div>

                          <div
                            style={{ width: "100%", alignItems: "center" }}
                            className="select-bank-popup-body-content-text-container"
                          >
                            <p className="select-bank-popup-body-content-text">
                              Last Name:
                            </p>
                            <p className="select-bank-popup-body-content-label">
                              {
                                userFullName?.split(" ")[
                                  userFullName?.split(" ")?.length - 1
                                ]
                              }
                            </p>
                          </div>

                          <div
                            style={{ width: "100%", alignItems: "center" }}
                            className="select-bank-popup-body-content-text-container"
                          >
                            <p className="select-bank-popup-body-content-text">
                              Email:
                            </p>
                            <p className="select-bank-popup-body-content-label">
                              {userEmail}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="asset-info-popup-second"></div>
            </div>
          )}
        </div>

        {!showSetCollateral && (
          <React.Fragment>
            <div
              style={{ marginTop: "50px", marginBottom: "50px" }}
              className="asset-info-popup-buttons"
            >
              {!showAssetTrading && (
                <>
                  <div
                    onClick={() => {
                      setShowAssetTrading(true);
                      setTradeType("sell");
                      setSelectedBank({
                        id: "",
                        name: "",
                        acct: "",
                        logo: "",
                      });
                      setSelectedBankIdx("");
                    }}
                    className="asset-info-popup-button-sell"
                  >
                    <p className="asset-info-popup-button-text">
                      {t("assetInfo.sell")}
                    </p>
                  </div>
                  <div
                    onClick={() => {
                      setShowAssetTrading(true);
                      setTradeType("buy");
                      setSelectedBank({
                        id: "",
                        name: "",
                        acct: "",
                        logo: "",
                      });
                      setSelectedBankIdx("");
                    }}
                    className="asset-info-popup-button-buy"
                  >
                    <p className="asset-info-popup-button-text">
                      {t("assetInfo.buy")}
                    </p>
                  </div>
                </>
              )}
              {showAssetTrading && tradeType === "buy" && (
                <div
                  onClick={async () => {
                    if (payWithVerifiedWallet) {
                      props.setFavouriteClicked(false);
                      props.setPopupContentPosition("flex-end");
                      props.setPopupContent(
                        <AddFunds
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          generalDataProps={props.generalDataProps}
                          addFundsAction="add-funds"
                        />,
                      );
                      setTradCategory("market");
                      setTradePrice(null);
                      setIsTradeInput(false);
                      setPayWithVerifiedWallet(false);
                      navigate("/payments/add-funds");
                    } else if (payWithBank) {
                      props.setFavouriteClicked(false);
                      props.setPopupContentPosition("flex-end");
                      props.setPopupContent(
                        <AddFunds
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          generalDataProps={props.generalDataProps}
                          addFundsAction="add-funds"
                        />,
                      );
                      setTradCategory("market");
                      setTradePrice(null);
                      setIsTradeInput(false);
                      setPayWithVerifiedWallet(false);
                      navigate("/payments/add-funds");
                    } else {
                      if (!marginCalculationLoading) {
                        await authenticateKYCStatus(
                          chainId,
                          userAddress,
                          web3,
                          appKitModal,
                          props.setPopupContent,
                          props.setPopupContentPosition,
                          props.setShowPopup,
                          props.setCustomLoading,
                          props.setFavouriteClicked,
                          false,
                          setVerifiedWalletDetails,
                          verifiedWalletDetails,
                          props.generalDataProps,
                        ).then(async (res) => {
                          if (
                            res &&
                            provider &&
                            signer &&
                            chainId > 0 &&
                            userAddress?.length > 0 &&
                            web3 &&
                            provider
                          ) {
                            if (
                              props.productClicked.poolType ===
                                PoolType.marginPool &&
                              marginCalculationLoading
                            ) {
                              errorToast(
                                "Required Collateral not calculated",
                                `Fees and required collateral amount not calculated. try again later`,
                              );
                              return;
                            }
                            if (Number(tradeAmount) <= 0) {
                              errorToast(
                                "Invalid amount to buy",
                                "Please enter a valid amount",
                              );
                              return;
                            }
                            if (
                              props.productClicked.poolType ===
                              PoolType.marginPool
                            ) {
                              if (
                                Number(collateralAdded) <
                                Number(requiredCollateral)
                              ) {
                                props.setCustomLoading(false);
                                errorToast(
                                  "Insufficient collateral balance!",
                                  `Top up collateral with at least: ${requiredCollateral?.toFixed(
                                    4,
                                  )} and try again.`,
                                );
                                return;
                              }

                              if (
                                Number(props.productClicked?.currentPrice) <= 0
                              ) {
                                props.setCustomLoading(false);
                                errorToast(
                                  "Invalid Price!",
                                  `This product can't be traded due to invalid price. Try again later`,
                                );
                                return;
                              }
                            }
                            if (
                              Object.keys(paraswapDetails).length === 0 &&
                              Number(tradeAmount) <
                                Number(props.productClicked?.minOrderSize)
                            ) {
                              errorToast(
                                "Amount lesser than minimum order size.",
                                props.productClicked?.minOrderSize
                                  ? `Please enter at least ${props.productClicked?.minOrderSize}`
                                  : "Please enter at least minimum order size",
                              );
                              return;
                            }

                            if (
                              props.productClicked?.poolType ===
                                PoolType.secondaryPool &&
                              Object.keys(paraswapDetails).length === 0 &&
                              Number(tradeAmount) >
                                Number(userBalances.currency)
                            ) {
                              props.setCustomLoading(false);
                              errorToast(
                                "Insufficient Balance",
                                `Amount to buy with can not be more than your balance: ${String(
                                  userBalances.currency,
                                )?.substring(0, 10)}`,
                              );
                              return;
                            }

                            if (
                              props.productClicked?.poolType !==
                                PoolType.marginPool &&
                              Object.keys(paraswapDetails).length === 0 &&
                              Number(tradeAmount) <
                                Number(props.productClicked?.minOrderSize)
                            ) {
                              props.setCustomLoading(false);
                              errorToast(
                                "Amount lesser than minimum order size.",
                                props.productClicked?.minOrderSize
                                  ? `The minimum order size is ${props.productClicked?.minOrderSize} ${props.productClicked?.currencySymbol}`
                                  : "Please enter at least minimum order size",
                              );
                              return;
                            }

                            if (
                              props.productClicked?.poolType !==
                                PoolType.marginPool &&
                              props.productClicked?.isCustodyTied &&
                              selectedBank?.id?.length === 0
                            ) {
                              setShowSetCollateral(true);
                              setShowSelectBank(true);
                              return;
                            }

                            if (
                              props.productClicked?.poolType !==
                                PoolType.marginPool &&
                              props.productClicked?.underlyingAssetId?.length >
                                0
                            ) {
                              setShowSetCollateral(true);
                              setShowUnderlyingAsset(true);
                              return;
                            }

                            let shouldProceed = true;
                            if (
                              props.productClicked?.poolType !==
                                PoolType.marginPool &&
                              props.productClicked?.isCustodyTied &&
                              selectedBank?.id?.length > 0 &&
                              !showCustodyAccounts
                            ) {
                              props.setCustomLoading(true);
                              await getUserCustodyBanks(
                                chainId,
                                userAddress,
                                signer,
                              ).then(async (res) => {
                                if (res) {
                                  if (
                                    res.length > 0 &&
                                    res?.find(
                                      (bnk) =>
                                        ethers.utils
                                          .parseBytes32String(bnk?.currency)
                                          ?.toLowerCase() ===
                                          "INICIADOR"?.toLowerCase() ||
                                        ethers.utils
                                          .parseBytes32String(bnk?.currency)
                                          ?.toLowerCase() ===
                                          "BLINK"?.toLowerCase(),
                                    )
                                  ) {
                                    const userIdRaw = selectedBank?.isBr
                                      ? res?.find(
                                          (bnk) =>
                                            ethers.utils
                                              .parseBytes32String(bnk?.currency)
                                              ?.toLowerCase() ===
                                            "INICIADOR"?.toLowerCase(),
                                        )?.account
                                      : res?.find(
                                          (bnk) =>
                                            ethers.utils
                                              .parseBytes32String(bnk?.currency)
                                              ?.toLowerCase() ===
                                            "BLINK"?.toLowerCase(),
                                        )?.account;

                                    const userId =
                                      ethers.utils.parseBytes32String(
                                        userIdRaw,
                                      );

                                    const custodyAcc = selectedBank?.isBr
                                      ? (await iniciadorUserAccounts(userId))
                                          ?.data
                                      : await blinkCustodyAccounts(
                                          userId,
                                          selectedBank?.id,
                                        );

                                    if (
                                      !custodyAcc ||
                                      custodyAcc?.length === 0
                                    ) {
                                      props.setCustomLoading(false);
                                      errorToast(
                                        "No Custody Account Found",
                                        "You have no custody account with the selected bank, select a new bank or reconnect bank.",
                                      );
                                      shouldProceed = false;
                                      return;
                                    }

                                    setBankList(custodyAcc);
                                    setBankListBr(custodyAcc);
                                    setShowSetCollateral(true);
                                    setShowSelectBank(true);
                                    setShowCustodyAccounts(true);
                                    props.setCustomLoading(false);
                                    shouldProceed = false;
                                  } else {
                                    props.setCustomLoading(false);
                                    errorToast(
                                      "No Linked Custody Bank",
                                      "You have no custody bank linked. Link Bank and try again.",
                                    );
                                    shouldProceed = false;
                                    return;
                                  }
                                } else {
                                  props.setCustomLoading(false);
                                  errorToast(
                                    "Unexpected Error!",
                                    "Unexpected error while fetching user bank details. Try again later",
                                  );
                                  shouldProceed = false;
                                  return;
                                }
                              });
                            }

                            if (Object.keys(paraswapDetails).length > 0) {
                              if (
                                Number(paraswapDetails.amount) <
                                Number(props.productClicked?.minOrderSize)
                              ) {
                                shouldProceed = false;
                                props.setCustomLoading(false);
                                errorToast(
                                  "Amount to swap lesser than minimum order size.",
                                  props.productClicked?.minOrderSize
                                    ? `Please swap out at least ${props.productClicked?.minOrderSize}`
                                    : "Please swap out at least minimum order size",
                                );

                                return;
                              }
                              props.setCustomLoading(true);
                              await swapTokenWithParaSwap(
                                userAddress,
                                chainId,
                                provider,
                                web3,
                                paraswapDetails.route,
                              ).then((res) => {
                                if (!res) {
                                  shouldProceed = false;
                                  props.setCustomLoading(false);
                                  errorToast(
                                    "Token Swap on Paraswap Failed.",
                                    `Create order with: ${props?.productClicked.currencySymbol} or try again.`,
                                  );
                                } else {
                                  shouldProceed = true;
                                  successToast(
                                    "Transaction Successful!",
                                    `${selectedCurrency.symbol} Swapped to ${props?.productClicked.currencySymbol} Successfully`,
                                    res?.hash ? res.hash : "",
                                  );
                                }
                              });
                            }
                            if (
                              shouldProceed &&
                              props.productClicked.poolType !==
                                PoolType.primaryPool
                            ) {
                              //handle margin and secondary pool buy
                              let amountInRaw, amountInWei;
                              const priceWei =
                                tradePrice > 0
                                  ? ethers.utils.parseEther(
                                      tradePrice.toString(),
                                    )
                                  : ethers.utils.parseEther(
                                      limitPrice.toString(),
                                    );
                              if (
                                props.productClicked.poolType ===
                                PoolType.marginPool
                              ) {
                                const _priceToUse =
                                  tradeCategory === "limit" &&
                                  Number(tradePrice) > 0
                                    ? tradePrice
                                    : tradeCategory === "limit" && limitPrice
                                      ? limitPrice
                                      : Number(newPrice) > 0
                                        ? Number(newPrice)
                                        : props.productClicked.currentPrice;
                                //use margin amount for margin buy
                                amountInRaw =
                                  Number(
                                    Number(
                                      // newPrice > 0
                                      //   ? newPrice
                                      //   : props.productClicked.currentPrice,

                                      _priceToUse,
                                    ) * Number(tradeAmount),
                                  ) *
                                    Number(props.productClicked.margin) >
                                  0
                                    ? Number(
                                        Number(
                                          // newPrice > 0
                                          //   ? newPrice
                                          //   : props.productClicked.currentPrice,
                                          _priceToUse,
                                        ) * Number(tradeAmount),
                                      ) *
                                      Number(props.productClicked.margin) *
                                      Number(props.productClicked?.swapFee)
                                    : 0;
                                amountInWei =
                                  Number(
                                    Number(
                                      // newPrice > 0
                                      //   ? newPrice
                                      //   : props.productClicked.currentPrice,
                                      _priceToUse,
                                    ) * Number(tradeAmount),
                                  ) *
                                    Number(props.productClicked.margin) >
                                  0
                                    ? ethers.utils.parseUnits(
                                        (
                                          Number(
                                            Number(
                                              // newPrice > 0
                                              //   ? newPrice
                                              //   : props.productClicked
                                              //       .currentPrice,
                                              _priceToUse,
                                            ) * Number(tradeAmount),
                                          ) *
                                          Number(props.productClicked.margin) *
                                          Number(props.productClicked?.swapFee)
                                        ).toFixed(
                                          Number(
                                            props.productClicked
                                              .currencyDecimals,
                                          ),
                                        ),
                                        props.productClicked.currencyDecimals.toString(),
                                      )
                                    : 0;
                              } else {
                                amountInRaw =
                                  Object.keys(paraswapDetails).length > 0
                                    ? Number(paraswapDetails?.amount)
                                    : Number(tradeAmount);
                                amountInWei =
                                  Object.keys(paraswapDetails).length > 0
                                    ? ethers.utils.parseUnits(
                                        Number(
                                          paraswapDetails?.amount,
                                        )?.toFixed(
                                          Number(
                                            props.productClicked
                                              .currencyDecimals,
                                          ),
                                        ),
                                        props.productClicked.currencyDecimals.toString(),
                                      )
                                    : ethers.utils.parseUnits(
                                        Number(tradeAmount).toFixed(
                                          Number(
                                            props.productClicked
                                              .currencyDecimals,
                                          ),
                                        ),
                                        props.productClicked.currencyDecimals.toString(),
                                      );
                              }

                              const isLimit =
                                tradeCategory === "limit" ? true : false;

                              if (
                                Object.keys(paraswapDetails).length === 0 &&
                                Number(amountInRaw) >
                                  Number(userBalances.currency)
                              ) {
                                props.setCustomLoading(false);
                                errorToast(
                                  "Insufficient Balance",
                                  `Amount to buy with can not be more than your balance: ${String(
                                    userBalances.currency,
                                  )?.substring(0, 10)}`,
                                );
                                return;
                              }

                              if (
                                Object.keys(paraswapDetails).length === 0 &&
                                Number(amountInRaw) <
                                  Number(props.productClicked?.minOrderSize)
                              ) {
                                props.setCustomLoading(false);
                                errorToast(
                                  "Amount lesser than minimum order size.",
                                  props.productClicked?.minOrderSize
                                    ? `The minimum order size is ${props.productClicked?.minOrderSize} ${props.productClicked?.currencySymbol}`
                                    : "Please enter at least minimum order size",
                                );
                                return;
                              }

                              if (Number(amountInWei) > 0) {
                                props.setCustomLoading(true);
                                let paymentToken;

                                if (
                                  verifiedWalletDetails &&
                                  Object?.keys(verifiedWalletDetails)?.length >
                                    0
                                ) {
                                  const cashTokens =
                                    await getAllVerifiedCashBalances(
                                      chainId,
                                      web3,
                                      userAddress,
                                    );
                                  if (!cashTokens || cashTokens?.length === 0) {
                                    props.setCustomLoading(false);
                                    errorToast(
                                      "Unexpected Error",
                                      "No valid Cash Token on this network. Change network and try again.",
                                    );

                                    return;
                                  }
                                  paymentToken = cashTokens[0];

                                  if (Number(cashTokens[0]?.balance) === 0) {
                                    props.setCustomLoading(false);
                                    errorToast(
                                      `Insufficient ${cashTokens[0]?.name} balance`,
                                      `Top up ${cashTokens[0]?.name} to proceed.`,
                                      <p
                                        className="general-web-toast-success-link-text"
                                        onClick={() => {
                                          props.setPopupContentPosition(
                                            "flex-end",
                                          );
                                          props.setPopupContent(
                                            <AddFunds
                                              setShowPopup={props.setShowPopup}
                                              setPopupContent={
                                                props.setPopupContent
                                              }
                                              setPopupContentPosition={
                                                props.setPopupContentPosition
                                              }
                                              customLoading={
                                                props.customLoading
                                              }
                                              setCustomLoading={
                                                props.setCustomLoading
                                              }
                                              generalDataProps={
                                                props.generalDataProps
                                              }
                                              addFundsAction="add-funds"
                                            />,
                                          );
                                          props.setShowPopup(true);
                                        }}
                                      >
                                        Top Up
                                      </p>,
                                    );

                                    return;
                                  }
                                }
                                await createSecondaryAndMarginOrder(
                                  paymentToken,
                                  chainId,
                                  userAddress,
                                  signer,
                                  props.productClicked.id,
                                  props.productClicked.currency,
                                  props.productClicked.address,
                                  "VPT",
                                  18,
                                  props.productClicked.tokensList,
                                  amountInWei,
                                  isLimit ? priceWei.toString() : "0",
                                  isLimit,
                                  provider,
                                  web3,
                                  custodyWalletDetails,
                                ).then(() => {
                                  setRefereshDetails(!refereshDetails);
                                  props.setCustomLoading(false);
                                });
                              } else {
                                props.setCustomLoading(false);
                                shouldProceed = false;
                                errorToast(
                                  "Unexpected error!",
                                  `Check product price and try again.`,
                                );
                                return;
                              }
                            } else if (shouldProceed) {
                              //handle primary pool buy

                              const amountInWei = ethers.utils.parseEther(
                                tradeAmount.toString(),
                              );
                              const calculatedAmountOut =
                                ethers.utils.parseUnits(
                                  sorValue.amountOut.toString(),
                                  Number(props.productClicked.currencyDecimals),
                                );

                              if (
                                Object.keys(paraswapDetails).length === 0 &&
                                Number(sorValue.amountOut) > 0 &&
                                Number(sorValue.amountOut) >
                                  Number(userBalances.currency)
                              ) {
                                props.setCustomLoading(false);
                                errorToast(
                                  "Insufficient Balance",
                                  `Amount to buy with can not be more than your balance: ${String(
                                    userBalances.currency,
                                  )?.substring(0, 10)}`,
                                );
                                return;
                              }
                              props.setCustomLoading(true);
                              const issueManagerAddress =
                                contractAddress[chainId]
                                  .BalancerPrimaryIssueManager;
                              let paymentToken;

                              if (
                                verifiedWalletDetails &&
                                Object?.keys(verifiedWalletDetails)?.length > 0
                              ) {
                                const cashTokens =
                                  await getAllVerifiedCashBalances(
                                    chainId,
                                    web3,
                                    userAddress,
                                  );
                                if (!cashTokens || cashTokens?.length === 0) {
                                  props.setCustomLoading(false);
                                  errorToast(
                                    "Unexpected Error",
                                    "No valid Cash Token on this network. Change network and try again.",
                                  );

                                  return;
                                }
                                paymentToken = cashTokens[0];

                                if (Number(cashTokens[0]?.balance) === 0) {
                                  props.setCustomLoading(false);
                                  errorToast(
                                    `Insufficient ${cashTokens[0]?.name} balance`,
                                    `Top up ${cashTokens[0]?.name} to proceed.`,
                                    <p
                                      className="general-web-toast-success-link-text"
                                      onClick={() => {
                                        props.setPopupContentPosition(
                                          "flex-end",
                                        );
                                        props.setPopupContent(
                                          <AddFunds
                                            setShowPopup={props.setShowPopup}
                                            setPopupContent={
                                              props.setPopupContent
                                            }
                                            setPopupContentPosition={
                                              props.setPopupContentPosition
                                            }
                                            customLoading={props.customLoading}
                                            setCustomLoading={
                                              props.setCustomLoading
                                            }
                                            generalDataProps={
                                              props.generalDataProps
                                            }
                                            addFundsAction="add-funds"
                                          />,
                                        );
                                        props.setShowPopup(true);
                                      }}
                                    >
                                      Top Up
                                    </p>,
                                  );

                                  return;
                                }
                              }

                              await createPrimaryOrder(
                                provider,
                                web3,
                                custodyWalletDetails,
                                paymentToken,
                                chainId,
                                userAddress,
                                signer,
                                props.productClicked.id,
                                props.productClicked.currency,
                                props.productClicked.security,
                                props.productClicked.securitySymbol,
                                Number(props.productClicked.securityDecimals),
                                props.productClicked.tokensList,
                                amountInWei,
                                calculatedAmountOut,
                                issueManagerAddress,
                                "buy",
                              ).then(() => {
                                setRefereshDetails(!refereshDetails);
                                props.setCustomLoading(false);
                              });
                            }
                          }
                        });
                      }
                    }
                  }}
                  style={{ width: "100%", marginBottom: "50px" }}
                  className="asset-info-popup-button-buy"
                >
                  {props.productClicked?.poolType !== PoolType.marginPool &&
                  props.productClicked?.isCustodyTied &&
                  selectedBank?.id?.length === 0 ? (
                    <p className="asset-info-popup-button-text">
                      {t("common.proceed")}
                    </p>
                  ) : props.productClicked?.poolType !== PoolType.marginPool &&
                    props.productClicked?.isCustodyTied &&
                    selectedBank?.id?.length > 0 &&
                    !showCustodyAccounts ? (
                    <p className="asset-info-popup-button-text">
                      {t("common.proceed")}
                    </p>
                  ) : props.productClicked?.poolType !== PoolType.marginPool &&
                    props.productClicked?.underlyingAssetId?.length > 0 ? (
                    <p className="asset-info-popup-button-text">
                      {t("common.proceed")}
                    </p>
                  ) : (
                    <p className="asset-info-popup-button-text">
                      {t("assetInfo.buy")}
                    </p>
                  )}
                </div>
              )}
              {showAssetTrading && tradeType === "sell" && (
                <div
                  onClick={async () => {
                    if (payWithVerifiedWallet) {
                      props.setFavouriteClicked(false);
                      props.setPopupContentPosition("flex-end");
                      props.setPopupContent(
                        <AddFunds
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          generalDataProps={props.generalDataProps}
                          addFundsAction="add-funds"
                        />,
                      );
                      setTradCategory("market");
                      setTradePrice(null);
                      setIsTradeInput(false);
                      setPayWithVerifiedWallet(false);
                      setPayWithBank(false);
                      navigate("/payments/add-funds");
                    } else {
                      if (!marginCalculationLoading) {
                        await authenticateKYCStatus(
                          chainId,
                          userAddress,
                          web3,
                          appKitModal,
                          props.setPopupContent,
                          props.setPopupContentPosition,
                          props.setShowPopup,
                          props.setCustomLoading,
                          props.setFavouriteClicked,
                          false,
                          setVerifiedWalletDetails,
                          verifiedWalletDetails,
                          props.generalDataProps,
                        ).then(async (res) => {
                          if (
                            res &&
                            provider &&
                            signer &&
                            chainId > 0 &&
                            userAddress?.length > 0 &&
                            web3 &&
                            provider
                          ) {
                            if (
                              props.productClicked.poolType ===
                                PoolType.marginPool &&
                              marginCalculationLoading
                            ) {
                              errorToast(
                                "Required Collateral not calculated",
                                `Fees and required collateral amount not calculated. try again later`,
                              );
                              return;
                            }
                            if (Number(tradeAmount) <= 0) {
                              errorToast(
                                "Invalid amount to buy",
                                "Please enter a valid amount",
                              );
                              return;
                            }
                            if (
                              Number(tradeAmount) <
                              Number(props.productClicked?.minOrderSize)
                            ) {
                              errorToast(
                                "Amount lesser than minimum order size.",
                                props.productClicked?.minOrderSize
                                  ? `Please enter at least ${props.productClicked?.minOrderSize}`
                                  : "Please enter at least minimum order size",
                              );

                              return;
                            }

                            if (
                              props.productClicked.poolType !==
                                PoolType.marginPool &&
                              Number(tradeAmount) >
                                Number(userBalances.security)
                            ) {
                              props.setCustomLoading(false);
                              errorToast(
                                "Insufficient Balance",
                                `Amount to sell can not be more than your balance: ${String(
                                  userBalances.security,
                                )?.substring(0, 10)}`,
                              );
                              return;
                            }

                            if (
                              props.productClicked.poolType ===
                              PoolType.marginPool
                            ) {
                              if (
                                Number(collateralAdded) <
                                Number(requiredCollateral)
                              ) {
                                props.setCustomLoading(false);
                                errorToast(
                                  "Insufficient collateral balance!",
                                  `Top up collateral with at least: ${requiredCollateral?.toFixed(
                                    4,
                                  )} and try again.`,
                                );
                                return;
                              }

                              if (
                                Number(props.productClicked?.currentPrice) <= 0
                              ) {
                                props.setCustomLoading(false);
                                errorToast(
                                  "Invalid Price!",
                                  `This product can't be traded due to invalid price. Try again later`,
                                );
                                return;
                              }
                            }

                            let shouldProceed = true;
                            if (
                              props.productClicked?.poolType ===
                                PoolType.secondaryPool &&
                              props.productClicked?.isCustodyTied &&
                              selectedBank?.id?.length === 0
                            ) {
                              setShowSetCollateral(true);
                              setShowSelectBank(true);
                              return;
                            }
                            props.setCustomLoading(true);
                            if (
                              props.productClicked?.poolType ===
                                PoolType.secondaryPool &&
                              props.productClicked?.isCustodyTied &&
                              selectedBank?.id?.length > 0 &&
                              !showCustodyAccounts
                            ) {
                              props.setCustomLoading(true);
                              await getUserCustodyBanks(
                                chainId,
                                userAddress,
                                signer,
                              ).then(async (res) => {
                                if (res) {
                                  if (
                                    res.length > 0 &&
                                    res?.find(
                                      (bnk) =>
                                        ethers.utils
                                          .parseBytes32String(bnk?.currency)
                                          ?.toLowerCase() ===
                                          "INICIADOR"?.toLowerCase() ||
                                        ethers.utils
                                          .parseBytes32String(bnk?.currency)
                                          ?.toLowerCase() ===
                                          "BLINK"?.toLowerCase(),
                                    )
                                  ) {
                                    const userIdRaw = selectedBank?.isBr
                                      ? res?.find(
                                          (bnk) =>
                                            ethers.utils
                                              .parseBytes32String(bnk?.currency)
                                              ?.toLowerCase() ===
                                            "INICIADOR"?.toLowerCase(),
                                        )?.account
                                      : res?.find(
                                          (bnk) =>
                                            ethers.utils
                                              .parseBytes32String(bnk?.currency)
                                              ?.toLowerCase() ===
                                            "BLINK"?.toLowerCase(),
                                        )?.account;

                                    const userId =
                                      ethers.utils.parseBytes32String(
                                        userIdRaw,
                                      );

                                    const custodyAcc = selectedBank?.isBr
                                      ? (await iniciadorUserAccounts(userId))
                                          ?.data
                                      : await blinkCustodyAccounts(
                                          userId,
                                          selectedBank?.id,
                                        );

                                    if (
                                      !custodyAcc ||
                                      custodyAcc?.length === 0
                                    ) {
                                      props.setCustomLoading(false);
                                      errorToast(
                                        "No Custody Account Found",
                                        "You have no custody account with the selected bank, select a new bank or reconnect bank.",
                                      );
                                      shouldProceed = false;
                                      return;
                                    }

                                    setBankList(custodyAcc);
                                    setBankListBr(custodyAcc);
                                    setShowSetCollateral(true);
                                    setShowSelectBank(true);
                                    setShowCustodyAccounts(true);
                                    props.setCustomLoading(false);
                                    shouldProceed = false;
                                  } else {
                                    props.setCustomLoading(false);
                                    errorToast(
                                      "No Linked Custody Bank",
                                      "You have no custody bank linked. Link Bank and try again.",
                                    );
                                    shouldProceed = false;
                                    return;
                                  }
                                } else {
                                  props.setCustomLoading(false);
                                  errorToast(
                                    "Unexpected Error!",
                                    "Unexpected error while fetching user bank details. Try again later",
                                  );
                                  shouldProceed = false;
                                  return;
                                }
                              });
                            }
                            if (
                              shouldProceed &&
                              props.productClicked.poolType !==
                                PoolType.primaryPool
                            ) {
                              const priceWei =
                                tradePrice > 0
                                  ? ethers.utils.parseEther(
                                      tradePrice.toString(),
                                    )
                                  : ethers.utils.parseEther(
                                      limitPrice.toString(),
                                    );
                              const amountInWei = ethers.utils.parseUnits(
                                tradeAmount.toString(),
                                props.productClicked.securityDecimals.toString(),
                              );
                              const isLimit =
                                tradeCategory === "limit" ? true : false;
                              let paymentToken;

                              if (
                                verifiedWalletDetails &&
                                Object?.keys(verifiedWalletDetails)?.length > 0
                              ) {
                                const cashTokens =
                                  await getAllVerifiedCashBalances(
                                    chainId,
                                    web3,
                                    userAddress,
                                  );
                                if (!cashTokens || cashTokens?.length === 0) {
                                  props.setCustomLoading(false);
                                  errorToast(
                                    "Unexpected Error",
                                    "No valid Cash Token on this network. Change network and try again.",
                                  );

                                  return;
                                }
                                paymentToken = cashTokens[0];

                                if (Number(cashTokens[0]?.balance) === 0) {
                                  props.setCustomLoading(false);
                                  errorToast(
                                    `Insufficient ${cashTokens[0]?.name} balance`,
                                    `Top up ${cashTokens[0]?.name} to proceed.`,
                                    <p
                                      className="general-web-toast-success-link-text"
                                      onClick={() => {
                                        props.setPopupContentPosition(
                                          "flex-end",
                                        );
                                        props.setPopupContent(
                                          <AddFunds
                                            setShowPopup={props.setShowPopup}
                                            setPopupContent={
                                              props.setPopupContent
                                            }
                                            setPopupContentPosition={
                                              props.setPopupContentPosition
                                            }
                                            customLoading={props.customLoading}
                                            setCustomLoading={
                                              props.setCustomLoading
                                            }
                                            generalDataProps={
                                              props.generalDataProps
                                            }
                                            addFundsAction="add-funds"
                                          />,
                                        );
                                        props.setShowPopup(true);
                                      }}
                                    >
                                      Top Up
                                    </p>,
                                  );

                                  return;
                                }
                              }

                              if (
                                props.productClicked.poolType ===
                                  PoolType.marginPool &&
                                Number(tradeAmount) >
                                  Number(userBalances.security)
                              ) {
                                const signature = await signer.signMessage(
                                  `Sign this message to request token topup.`,
                                );

                                const topupTokenRes = await fetch(
                                  `${sponsorTxUrl}/sponsorship/tktp/${chainId?.toString()}`,
                                  {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify({
                                      poolId: props.productClicked.id,
                                      tokenInAddress:
                                        props.productClicked.security,
                                      tokenOutAddress:
                                        props.productClicked.address,
                                      kind: "0",
                                      amount: amountInWei?.toString(),
                                      recipient: userAddress,
                                      sig: signature,
                                    }),
                                  },
                                );

                                if (topupTokenRes.ok) {
                                  console.log(
                                    "topup token successful will proceed to transaction...",
                                  );
                                }

                                if (!topupTokenRes.ok) {
                                  console.log(
                                    "topup token failed with error: ",
                                    topupTokenRes?.statusText,
                                  );

                                  props.setCustomLoading(false);
                                  errorToast(
                                    "Unexpected Error",
                                    "Security topup failed. Try again later",
                                  );

                                  return;
                                }
                              }

                              await createSecondaryAndMarginOrder(
                                paymentToken,
                                chainId,
                                userAddress,
                                signer,
                                props.productClicked.id,
                                props.productClicked.security,
                                props.productClicked.address,
                                "VPT",
                                18,
                                props.productClicked.tokensList,
                                amountInWei,
                                isLimit ? priceWei.toString() : "0",
                                isLimit,
                                provider,
                                web3,
                                custodyWalletDetails,
                              ).then(() => {
                                setRefereshDetails(!refereshDetails);
                                props.setCustomLoading(false);
                              });
                            } else if (shouldProceed) {
                              const amountInWei = ethers.utils.parseEther(
                                tradeAmount.toString(),
                              );
                              const calculatedAmountOut =
                                ethers.utils.parseUnits(
                                  sorValue.amountOut.toString(),
                                  Number(props.productClicked.currencyDecimals),
                                );
                              const issueManagerAddress =
                                contractAddress[chainId]
                                  .BalancerPrimaryIssueManager;
                              let paymentToken;

                              if (
                                verifiedWalletDetails &&
                                Object?.keys(verifiedWalletDetails)?.length > 0
                              ) {
                                const cashTokens =
                                  await getAllVerifiedCashBalances(
                                    chainId,
                                    web3,
                                    userAddress,
                                  );
                                if (!cashTokens || cashTokens?.length === 0) {
                                  props.setCustomLoading(false);
                                  errorToast(
                                    "Unexpected Error",
                                    "No valid Cash Token on this network. Change network and try again.",
                                  );

                                  return;
                                }
                                paymentToken = cashTokens[0];

                                if (Number(cashTokens[0]?.balance) === 0) {
                                  props.setCustomLoading(false);
                                  errorToast(
                                    `Insufficient ${cashTokens[0]?.name} balance`,
                                    `Top up ${cashTokens[0]?.name} to proceed.`,
                                    <p
                                      className="general-web-toast-success-link-text"
                                      onClick={() => {
                                        props.setPopupContentPosition(
                                          "flex-end",
                                        );
                                        props.setPopupContent(
                                          <AddFunds
                                            setShowPopup={props.setShowPopup}
                                            setPopupContent={
                                              props.setPopupContent
                                            }
                                            setPopupContentPosition={
                                              props.setPopupContentPosition
                                            }
                                            customLoading={props.customLoading}
                                            setCustomLoading={
                                              props.setCustomLoading
                                            }
                                            generalDataProps={
                                              props.generalDataProps
                                            }
                                            addFundsAction="add-funds"
                                          />,
                                        );
                                        props.setShowPopup(true);
                                      }}
                                    >
                                      Top Up
                                    </p>,
                                  );

                                  return;
                                }
                              }
                              await createPrimaryOrder(
                                provider,
                                web3,
                                custodyWalletDetails,
                                paymentToken,
                                chainId,
                                userAddress,
                                signer,
                                props.productClicked.id,
                                props.productClicked.security,
                                props.productClicked.currency,
                                props.productClicked.currencySymbol,
                                Number(props.productClicked.currencyDecimals),
                                props.productClicked.tokensList,
                                amountInWei,
                                calculatedAmountOut,
                                issueManagerAddress,
                                "sell",
                              ).then(async (res) => {
                                if (Object.keys(paraswapDetails).length > 0) {
                                  await swapTokenWithParaSwap(
                                    userAddress,
                                    chainId,
                                    provider,
                                    web3,
                                    paraswapDetails.route,
                                  ).then((res) => {
                                    if (!res) {
                                      toast.warn(
                                        `Token Swap on Paraswap Failed. ${props?.productClicked.currencySymbol} Has Been Deposited To Your Wallet`,
                                      );
                                    } else {
                                      successToast(
                                        "Transaction Successful!",
                                        `${props?.productClicked.currencySymbol} Swapped to ${selectedCurrency.symbol} Successfully`,
                                        res?.hash ? res.hash : "",
                                      );
                                    }
                                  });
                                }
                                setRefereshDetails(!refereshDetails);
                                props.setCustomLoading(false);
                              });
                            }
                          }
                        });
                      }
                    }
                  }}
                  style={{ width: "100%", marginBottom: "50px" }}
                  className="asset-info-popup-button-sell"
                >
                  {props.productClicked?.poolType === PoolType.secondaryPool &&
                  props.productClicked?.isCustodyTied &&
                  selectedBank?.id?.length === 0 ? (
                    <p className="asset-info-popup-button-text">
                      {t("common.proceed")}
                    </p>
                  ) : (
                    <p className="asset-info-popup-button-text">
                      {t("assetInfo.sell")}
                    </p>
                  )}
                </div>
              )}
            </div>
            {/* <button
              className="startup-button-click"
              style={{ marginBottom: "50px" }}
            >
              <p className="add-funds-popup-a-f-button-text">
                Manage Collateral
              </p>
            </button> */}
          </React.Fragment>
        )}

        {showSetCollateral && showSelectBank && !showCustodyAccounts && (
          <React.Fragment>
            {props.productClicked?.isCustodyTied && (
              <button
                style={{ marginTop: "50px", marginBottom: "50px" }}
                onClick={() => {
                  setShowSelectBank(false);
                  setShowSetCollateral(false);
                }}
                className="asset-info-popup-collateral-button"
              >
                <p className="asset-info-popup-collateral-button-text">
                  {t("common.proceed")}
                </p>
              </button>
            )}
          </React.Fragment>
        )}

        {showSetCollateral && showSelectBank && showCustodyAccounts && (
          <React.Fragment>
            {props.productClicked?.isCustodyTied && (
              <button
                style={{ marginTop: "50px", marginBottom: "50px" }}
                onClick={() => {
                  setShowSelectBank(false);
                  setShowSetCollateral(false);
                }}
                className="asset-info-popup-collateral-button"
              >
                <p className="asset-info-popup-collateral-button-text">
                  {t("confirmation.confirm")}
                </p>
              </button>
            )}
          </React.Fragment>
        )}

        {showSetCollateral && showUnderlyingAsset && (
          <React.Fragment>
            {userCustomerAccount?.cashAccountNumber === "" && (
              <button
                style={{ marginTop: "50px", marginBottom: "50px" }}
                className="asset-info-popup-collateral-button"
                onClick={async () => {
                  setCustomPopupPosition("flex-end");
                  setCustomPopupContent(
                    <PaymentProcess title={"Checking KYC status"} />,
                  );
                  setShowCustomPopup(true);
                  await authenticateKYCStatus(
                    chainId,
                    userAddress,
                    web3,
                    appKitModal,
                    props.setPopupContent,
                    props.setPopupContentPosition,
                    props.setShowPopup,
                    props.setCustomLoading,
                    props.setFavouriteClicked,
                    false,
                    setVerifiedWalletDetails,
                    verifiedWalletDetails,
                    props.generalDataProps,
                  ).then(async (res) => {
                    if (
                      res &&
                      signer &&
                      chainId > 0 &&
                      userAddress?.length > 0 &&
                      web3 &&
                      provider
                    ) {
                      if (userFullName === "") {
                        setCustomPopupPosition("center");
                        setCustomPopupContent(null);
                        setShowCustomPopup(false);
                        errorToast(
                          "Invalid user first/last name",
                          "Please connect a wallet with valid name and try again",
                        );
                        return;
                      }
                      if (userEmail === "") {
                        setCustomPopupPosition("center");
                        setCustomPopupContent(null);
                        setShowCustomPopup(false);
                        errorToast(
                          "Invalid email address",
                          "Please connect a wallet with valid email and try again",
                        );
                        return;
                      }

                      setCustomPopupPosition("flex-end");
                      setCustomPopupContent(
                        <PaymentProcess
                          title={"Account Creation"}
                          description={"Creating Customer Account..."}
                        />,
                      );
                      const customerId = await createNewCustomer(
                        userFirstName,
                        userFullName?.split(" ")[
                          userFullName?.split(" ")?.length - 1
                        ],
                        userEmail,
                      );
                      if (customerId?.length > 0) {
                        setUser({
                          name: "userGTNCustomerId",
                          value: customerId,
                        });
                        const customerDetails =
                          await fetchCustomerDetails(customerId);
                        if (customerDetails?.length > 0) {
                          setUserCustomerAccount(customerDetails[0]);
                        }
                        successToast(
                          "Account created!",
                          "Customer Account created successfully",
                        );

                        setCustomPopupPosition("flex-end");
                        setCustomPopupContent(
                          <PaymentProcess
                            title={"Transaction Processing"}
                            description={
                              "Saving created customer account on smart contract. Approve transaction to continue"
                            }
                          />,
                        );
                        setShowCustomPopup(true);
                        let paymentToken;
                        if (
                          verifiedWalletDetails &&
                          Object?.keys(verifiedWalletDetails)?.length > 0 &&
                          chainId &&
                          web3 &&
                          userAddress
                        ) {
                          const cashTokens = await getAllVerifiedCashBalances(
                            chainId,
                            web3,
                            userAddress,
                          );

                          paymentToken = cashTokens[0];
                        }
                        await setUserCustodyBanks(
                          chainId,
                          userAddress,
                          signer,
                          "GTN:",
                          customerId,
                          paymentToken,
                          provider,
                          web3,
                          custodyWalletDetails,
                        ).then((hash) => {
                          props.setCustomLoading(false);
                          if (hash) {
                            custodyWalletDetails?.custodyId?.length > 0
                              ? successToast(
                                  "Transaction Successful!",
                                  "Set user customer account successfully.",
                                )
                              : successToast(
                                  "Transaction Successful!",
                                  "Set user customer account successfully.",
                                  hash,
                                );

                            setCustomPopupPosition("center");
                            setCustomPopupContent(null);
                            setShowCustomPopup(false);
                            successToast(
                              "Transaction Successful!",
                              "Set user customer account successfully.",
                            );

                            props.setPopupContent(
                              <SuccessPopup
                                setShowPopup={props.setShowPopup}
                                setPopupContent={props.setPopupContent}
                                setPopupContentPosition={
                                  props.setPopupContentPosition
                                }
                                isCustom={true}
                                customTextHeader="Congratulations!"
                                customTextFooter={`You have successfully setup a new customer account. Top Up account to start trading`}
                                setFavouriteClicked={props.setFavouriteClicked}
                                showButton={true}
                                buttonText={"Top Up Account"}
                                buttonFunc={() => {
                                  props.setPopupContentPosition("flex-end");
                                  props.setPopupContent(
                                    <AddFunds
                                      setShowPopup={props.setShowPopup}
                                      setPopupContent={props.setPopupContent}
                                      setPopupContentPosition={
                                        props.setPopupContentPosition
                                      }
                                      customLoading={props.customLoading}
                                      setFavouriteClicked={
                                        props.setFavouriteClicked
                                      }
                                      setCustomLoading={props.setCustomLoading}
                                      generalDataProps={props.generalDataProps}
                                      addFundsAction="add-funds-others"
                                      accountBalance={
                                        userCustomerAccount?.balance
                                      }
                                      accountCurrency={
                                        userCustomerAccount?.currency
                                      }
                                      accountNumber={customerId}
                                    />,
                                  );
                                  props.setShowPopup(true);
                                }}
                              />,
                            );
                            props.setPopupContentPosition("flex-end");
                            props.setShowPopup(true);
                          } else {
                            setCustomPopupPosition("flex-end");
                            setCustomPopupContent(
                              <SuccessPopup
                                setShowPopup={props.setShowPopup}
                                setPopupContent={props.setPopupContent}
                                setPopupContentPosition={
                                  props.setPopupContentPosition
                                }
                                isCustom={true}
                                customTextHeader="Transaction Failed!"
                                customTextFooter="Set new account details failed"
                                setFavouriteClicked={props.setFavouriteClicked}
                                isError={true}
                                setCustomPopupPosition={setCustomPopupPosition}
                                setCustomPopupContent={setCustomPopupContent}
                                setShowCustomPopup={setShowCustomPopup}
                              />,
                            );
                            setShowCustomPopup(true);
                            errorToast(
                              "Oops Something went wrong",
                              "Error while setting user account. Try again later.",
                            );
                            setUser({
                              name: "userGTNCustomerId",
                              value: "",
                            });
                            return;
                          }
                        });
                      } else {
                        setCustomPopupPosition("flex-end");
                        setCustomPopupContent(
                          <SuccessPopup
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            isCustom={true}
                            customTextHeader="Account Creation Failed"
                            customTextFooter="Error while creating account"
                            setFavouriteClicked={props.setFavouriteClicked}
                            isError={true}
                            setCustomPopupPosition={setCustomPopupPosition}
                            setCustomPopupContent={setCustomPopupContent}
                            setShowCustomPopup={setShowCustomPopup}
                          />,
                        );
                        setShowCustomPopup(true);

                        errorToast(
                          "unexpected Error!",
                          "Create new customer account failed. Try again later",
                        );
                        setUser({
                          name: "userGTNCustomerId",
                          value: "",
                        });
                        return;
                      }
                      props.setCustomLoading(false);
                    } else {
                      setCustomPopupPosition("center");
                      setCustomPopupContent(null);
                      setShowCustomPopup(false);
                      errorToast(
                        "Oops Something went wrong",
                        "Unexpected error. Try again later",
                      );
                      return;
                    }
                  });
                }}
              >
                <p className="asset-info-popup-collateral-button-text">
                  Create Account
                </p>
              </button>
            )}

            {(userCustomerAccount?.cashAccountNumber !== "" &&
              tradeType === "buy" &&
              props.productClicked.poolType === PoolType.primaryPool &&
              Number(userCustomerAccount?.balance) <
                Number(tradeAmount) *
                  Number(
                    underlyingAssetDt?.price ||
                      props.productClicked?.underlyingAsset?.price,
                  )) ||
              (userCustomerAccount?.cashAccountNumber !== "" &&
                tradeType === "buy" &&
                props.productClicked.poolType !== PoolType.primaryPool &&
                Number(userCustomerAccount?.balance) < Number(tradeAmount) && (
                  <button
                    style={{ marginTop: "50px", marginBottom: "50px" }}
                    className="asset-info-popup-collateral-button"
                    onClick={() => {
                      props.setPopupContentPosition("flex-end");
                      props.setPopupContent(
                        <AddFunds
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          customLoading={props.customLoading}
                          setFavouriteClicked={props.setFavouriteClicked}
                          setCustomLoading={props.setCustomLoading}
                          generalDataProps={props.generalDataProps}
                          addFundsAction="add-funds-others"
                          accountBalance={userCustomerAccount?.balance}
                          accountCurrency={userCustomerAccount?.currency}
                          accountNumber={userGTNCustomerId}
                        />,
                      );
                      props.setShowPopup(true);
                    }}
                  >
                    <p className="asset-info-popup-collateral-button-text">
                      Top Up Account
                    </p>
                  </button>
                ))}

            {(userCustomerAccount?.cashAccountNumber !== "" &&
              tradeType === "buy" &&
              props.productClicked.poolType === PoolType.primaryPool &&
              Number(userCustomerAccount?.balance) >=
                Number(tradeAmount) *
                  Number(
                    underlyingAssetDt?.price ||
                      props.productClicked?.underlyingAsset?.price,
                  )) ||
              (userCustomerAccount?.cashAccountNumber !== "" &&
                tradeType === "buy" &&
                props.productClicked.poolType !== PoolType.primaryPool &&
                Number(userCustomerAccount?.balance) >= Number(tradeAmount) && (
                  <button
                    style={{
                      marginTop: "50px",
                      marginBottom: "50px",
                      width: "100%",
                      background: "var(--Success-600, #41732f)",
                    }}
                    className="asset-info-popup-collateral-button"
                    onClick={async () => {
                      if (
                        props.productClicked.poolType ===
                          PoolType.primaryPool &&
                        Number(
                          underlyingAssetDt?.equityLotSize ||
                            props.productClicked?.underlyingAsset
                              ?.equityLotSize,
                        ) > 0 &&
                        Number(tradeAmount) <
                          Number(
                            underlyingAssetDt?.equityLotSize ||
                              props.productClicked?.underlyingAsset
                                ?.equityLotSize,
                          )
                      ) {
                        setCustomPopupPosition("center");
                        setCustomPopupContent(null);
                        setShowCustomPopup(false);
                        errorToast(
                          "Amount lesser than minimum lot size",
                          `Minimum Asset Lot Size is ${Number(
                            underlyingAssetDt?.equityLotSize ||
                              props.productClicked?.underlyingAsset
                                ?.equityLotSize,
                          )?.toFixed(2)} increase amount and try again.`,
                        );
                        return;
                      }

                      if (
                        props.productClicked.poolType === PoolType.marginPool &&
                        marginCalculationLoading
                      ) {
                        setCustomPopupPosition("center");
                        setCustomPopupContent(null);
                        setShowCustomPopup(false);
                        errorToast(
                          "Required Collateral not calculated",
                          `Fees and required collateral amount not calculated. try again later`,
                        );
                        return;
                      }

                      if (
                        props.productClicked.poolType !==
                          PoolType.primaryPool &&
                        Number(
                          underlyingAssetDt?.equityLotSize ||
                            props.productClicked?.underlyingAsset
                              ?.equityLotSize,
                        ) > 0 &&
                        Number(
                          Number(tradeAmount) /
                            Number(
                              underlyingAssetDt?.price ||
                                props.productClicked?.underlyingAsset?.price,
                            ),
                        ) <
                          Number(
                            underlyingAssetDt?.equityLotSize ||
                              props.productClicked?.underlyingAsset
                                ?.equityLotSize,
                          )
                      ) {
                        setCustomPopupPosition("center");
                        setCustomPopupContent(null);
                        setShowCustomPopup(false);
                        errorToast(
                          "Amount lesser than minimum lot size",
                          `Minimum Asset Lot Size is ${Number(
                            underlyingAssetDt?.equityLotSize ||
                              props.productClicked?.underlyingAsset
                                ?.equityLotSize,
                          )?.toFixed(2)} increase amount and try again.`,
                        );
                        return;
                      }

                      setCustomPopupPosition("flex-end");
                      setCustomPopupContent(
                        <PaymentProcess title={"Checking KYC status"} />,
                      );
                      setShowCustomPopup(true);
                      await authenticateKYCStatus(
                        chainId,
                        userAddress,
                        web3,
                        appKitModal,
                        props.setPopupContent,
                        props.setPopupContentPosition,
                        props.setShowPopup,
                        props.setCustomLoading,
                        props.setFavouriteClicked,
                        false,
                        setVerifiedWalletDetails,
                        verifiedWalletDetails,
                        props.generalDataProps,
                      ).then(async (res) => {
                        if (
                          res &&
                          signer &&
                          chainId > 0 &&
                          userAddress?.length > 0 &&
                          web3 &&
                          provider
                        ) {
                          const securityAccount =
                            userCustomerAccount?.securityAccounts[0]
                              ?.accountNumber;
                          if (!securityAccount) {
                            setCustomPopupPosition("center");
                            setCustomPopupContent(null);
                            setShowCustomPopup(false);
                            errorToast(
                              "Invalid user security account",
                              "Please connect a wallet with a complete account registration.",
                            );
                            return;
                          }

                          setCustomPopupPosition("flex-end");
                          setCustomPopupContent(
                            <PaymentProcess
                              title={"Buying Asset on Exchange "}
                              description={"Creating Buy Order for Asset..."}
                            />,
                          );

                          const abiCoder = new ethers.utils.AbiCoder();
                          const userData =
                            props.productClicked?.prices?.length === 0
                              ? abiCoder.encode(
                                  ["bytes32", "uint"],
                                  [
                                    ethers.utils.formatBytes32String("Limit"),
                                    ethers.utils.parseEther(
                                      Number(
                                        underlyingAssetDt?.price ||
                                          props.productClicked?.underlyingAsset
                                            ?.price,
                                      ).toString(),
                                    ),
                                  ],
                                )
                              : "0x";

                          const oppositeOrder = {
                            orderAmount: ethers.utils
                              .parseEther(
                                props.productClicked.poolType ===
                                  PoolType.primaryPool
                                  ? tradeAmount?.toString()
                                  : String(
                                      Number(tradeAmount) /
                                        Number(
                                          underlyingAssetDt?.price ||
                                            props.productClicked
                                              ?.underlyingAsset?.price,
                                        ),
                                    ),
                              )
                              ?.toString(),
                            orderId: "",
                            userData: userData,
                            poolId: props.productClicked.id,
                            tokenIn: props.productClicked.security,
                            tokenOut: props.productClicked.address,
                            tokensList: props.productClicked.tokensList,
                            orderOffchainId: "",
                            chainId: chainId?.toString(),
                          };
                          // console.log("opposite: ", oppositeOrder);
                          const orderRes = await createOrder(
                            userGTNCustomerId,
                            securityAccount,
                            props?.productClicked?.underlyingAssetId?.split(
                              "~",
                            )[1],
                            props?.productClicked?.underlyingAssetId?.split(
                              "~",
                            )[0],
                            props?.productClicked?.underlyingAssetId,
                            props.productClicked.poolType ===
                              PoolType.primaryPool
                              ? tradeAmount
                              : String(
                                  Number(tradeAmount) /
                                    Number(
                                      underlyingAssetDt?.price ||
                                        props.productClicked?.underlyingAsset
                                          ?.price,
                                    ),
                                ),
                            tradeType,
                            oppositeOrder,
                          );
                          if (orderRes) {
                            successToast(
                              "Order created",
                              "Buy order created successfully",
                            );

                            setCustomPopupPosition("flex-end");
                            setCustomPopupContent(
                              <PaymentProcess
                                title={"Transaction Processing"}
                                description={
                                  "Creating Order on smart contract. Approve transaction to continue"
                                }
                              />,
                            );
                            setShowCustomPopup(true);
                            let shouldProceed = true;
                            if (
                              shouldProceed &&
                              props.productClicked.poolType !==
                                PoolType.primaryPool
                            ) {
                              //handle margin and secondary pool buy
                              let amountInRaw, amountInWei;
                              const priceWei =
                                tradePrice > 0
                                  ? ethers.utils.parseEther(
                                      tradePrice.toString(),
                                    )
                                  : ethers.utils.parseEther(
                                      limitPrice.toString(),
                                    );
                              if (
                                props.productClicked.poolType ===
                                PoolType.marginPool
                              ) {
                                //use margin amount for margin buy
                                amountInRaw =
                                  Number(
                                    Number(
                                      newPrice > 0
                                        ? newPrice
                                        : props.productClicked.currentPrice,
                                    ) * Number(tradeAmount),
                                  ) *
                                    Number(props.productClicked.margin) >
                                  0
                                    ? Number(
                                        Number(
                                          newPrice > 0
                                            ? newPrice
                                            : props.productClicked.currentPrice,
                                        ) * Number(tradeAmount),
                                      ) * Number(props.productClicked.margin)
                                    : 0;
                                amountInWei =
                                  Number(
                                    Number(
                                      newPrice > 0
                                        ? newPrice
                                        : props.productClicked.currentPrice,
                                    ) * Number(tradeAmount),
                                  ) *
                                    Number(props.productClicked.margin) >
                                  0
                                    ? ethers.utils.parseUnits(
                                        (
                                          Number(
                                            Number(
                                              newPrice > 0
                                                ? newPrice
                                                : props.productClicked
                                                    .currentPrice,
                                            ) * Number(tradeAmount),
                                          ) *
                                          Number(props.productClicked.margin)
                                        ).toFixed(
                                          Number(
                                            props.productClicked
                                              .currencyDecimals,
                                          ),
                                        ),
                                        props.productClicked.currencyDecimals.toString(),
                                      )
                                    : 0;
                              } else {
                                amountInRaw =
                                  Object.keys(paraswapDetails).length > 0
                                    ? Number(paraswapDetails?.amount)
                                    : Number(tradeAmount);
                                amountInWei =
                                  Object.keys(paraswapDetails).length > 0
                                    ? ethers.utils.parseUnits(
                                        Number(
                                          paraswapDetails?.amount,
                                        )?.toFixed(
                                          Number(
                                            props.productClicked
                                              .currencyDecimals,
                                          ),
                                        ),
                                        props.productClicked.currencyDecimals.toString(),
                                      )
                                    : ethers.utils.parseUnits(
                                        Number(tradeAmount).toFixed(
                                          Number(
                                            props.productClicked
                                              .currencyDecimals,
                                          ),
                                        ),
                                        props.productClicked.currencyDecimals.toString(),
                                      );
                              }

                              const isLimit =
                                tradeCategory === "limit" ? true : false;

                              if (
                                Object.keys(paraswapDetails).length === 0 &&
                                Number(amountInRaw) <
                                  Number(props.productClicked?.minOrderSize)
                              ) {
                                setCustomPopupPosition("center");
                                setCustomPopupContent(null);
                                setShowCustomPopup(false);
                                errorToast(
                                  "Amount lesser than minimum order size.",
                                  props.productClicked?.minOrderSize
                                    ? `The minimum order size is ${props.productClicked?.minOrderSize} ${props.productClicked?.currencySymbol}`
                                    : "Please enter at least minimum order size",
                                );
                                return;
                              }

                              if (Number(amountInWei) > 0) {
                                props.setCustomLoading(true);
                                let paymentToken;

                                if (
                                  verifiedWalletDetails &&
                                  Object?.keys(verifiedWalletDetails)?.length >
                                    0
                                ) {
                                  const cashTokens =
                                    await getAllVerifiedCashBalances(
                                      chainId,
                                      web3,
                                      userAddress,
                                    );
                                  if (!cashTokens || cashTokens?.length === 0) {
                                    setCustomPopupPosition("center");
                                    setCustomPopupContent(null);
                                    setShowCustomPopup(false);
                                    errorToast(
                                      "Unexpected Error",
                                      "No valid Cash Token on this network. Change network and try again.",
                                    );

                                    return;
                                  }
                                  paymentToken = cashTokens[0];

                                  if (Number(cashTokens[0]?.balance) === 0) {
                                    setCustomPopupPosition("center");
                                    setCustomPopupContent(null);
                                    setShowCustomPopup(false);

                                    errorToast(
                                      `Insufficient ${cashTokens[0]?.name} balance`,
                                      `Top up ${cashTokens[0]?.name} to proceed.`,
                                      <p
                                        className="general-web-toast-success-link-text"
                                        onClick={() => {
                                          props.setPopupContentPosition(
                                            "flex-end",
                                          );
                                          props.setPopupContent(
                                            <AddFunds
                                              setShowPopup={props.setShowPopup}
                                              setPopupContent={
                                                props.setPopupContent
                                              }
                                              setPopupContentPosition={
                                                props.setPopupContentPosition
                                              }
                                              customLoading={
                                                props.customLoading
                                              }
                                              setCustomLoading={
                                                props.setCustomLoading
                                              }
                                              generalDataProps={
                                                props.generalDataProps
                                              }
                                              addFundsAction="add-funds"
                                            />,
                                          );
                                          props.setShowPopup(true);
                                        }}
                                      >
                                        Top Up
                                      </p>,
                                    );

                                    return;
                                  }
                                }
                                await createSecondaryAndMarginOrder(
                                  paymentToken,
                                  chainId,
                                  userAddress,
                                  signer,
                                  props.productClicked.id,
                                  props.productClicked.currency,
                                  props.productClicked.address,
                                  "VPT",
                                  18,
                                  props.productClicked.tokensList,
                                  amountInWei,
                                  isLimit ? priceWei.toString() : "0",
                                  isLimit,
                                  provider,
                                  web3,
                                  custodyWalletDetails,
                                ).then(() => {
                                  setRefereshDetails(!refereshDetails);
                                  setCustomPopupPosition("center");
                                  setCustomPopupContent(null);
                                  setShowCustomPopup(false);
                                });
                              } else {
                                shouldProceed = false;
                                setCustomPopupPosition("center");
                                setCustomPopupContent(null);
                                setShowCustomPopup(false);
                                errorToast(
                                  "Unexpected error!",
                                  `Check product price and try again.`,
                                );
                                return;
                              }
                            } else if (shouldProceed) {
                              //handle primary pool buy

                              const amountInWei = ethers.utils.parseEther(
                                tradeAmount.toString(),
                              );
                              const calculatedAmountOut =
                                ethers.utils.parseUnits(
                                  sorValue.amountOut.toString(),
                                  Number(props.productClicked.currencyDecimals),
                                );

                              if (
                                Object.keys(paraswapDetails).length === 0 &&
                                Number(sorValue.amountOut) > 0 &&
                                Number(sorValue.amountOut) >
                                  Number(userBalances.currency)
                              ) {
                                setCustomPopupPosition("center");
                                setCustomPopupContent(null);
                                setShowCustomPopup(false);
                                errorToast(
                                  "Insufficient Balance",
                                  `Amount to buy with can not be more than your balance: ${String(
                                    userBalances.currency,
                                  )?.substring(0, 10)}`,
                                );
                                return;
                              }

                              const issueManagerAddress =
                                contractAddress[chainId]
                                  .BalancerPrimaryIssueManager;
                              let paymentToken;

                              if (
                                verifiedWalletDetails &&
                                Object?.keys(verifiedWalletDetails)?.length > 0
                              ) {
                                const cashTokens =
                                  await getAllVerifiedCashBalances(
                                    chainId,
                                    web3,
                                    userAddress,
                                  );
                                if (!cashTokens || cashTokens?.length === 0) {
                                  setCustomPopupPosition("center");
                                  setCustomPopupContent(null);
                                  setShowCustomPopup(false);
                                  errorToast(
                                    "Unexpected Error",
                                    "No valid Cash Token on this network. Change network and try again.",
                                  );

                                  return;
                                }
                                paymentToken = cashTokens[0];

                                if (Number(cashTokens[0]?.balance) === 0) {
                                  setCustomPopupPosition("center");
                                  setCustomPopupContent(null);
                                  setShowCustomPopup(false);
                                  errorToast(
                                    `Insufficient ${cashTokens[0]?.name} balance`,
                                    `Top up ${cashTokens[0]?.name} to proceed.`,
                                    <p
                                      className="general-web-toast-success-link-text"
                                      onClick={() => {
                                        props.setPopupContentPosition(
                                          "flex-end",
                                        );
                                        props.setPopupContent(
                                          <AddFunds
                                            setShowPopup={props.setShowPopup}
                                            setPopupContent={
                                              props.setPopupContent
                                            }
                                            setPopupContentPosition={
                                              props.setPopupContentPosition
                                            }
                                            customLoading={props.customLoading}
                                            setCustomLoading={
                                              props.setCustomLoading
                                            }
                                            generalDataProps={
                                              props.generalDataProps
                                            }
                                            addFundsAction="add-funds"
                                          />,
                                        );
                                        props.setShowPopup(true);
                                      }}
                                    >
                                      Top Up
                                    </p>,
                                  );

                                  return;
                                }
                              }

                              await createPrimaryOrder(
                                provider,
                                web3,
                                custodyWalletDetails,
                                paymentToken,
                                chainId,
                                userAddress,
                                signer,
                                props.productClicked.id,
                                props.productClicked.currency,
                                props.productClicked.security,
                                props.productClicked.securitySymbol,
                                Number(props.productClicked.securityDecimals),
                                props.productClicked.tokensList,
                                amountInWei,
                                calculatedAmountOut,
                                issueManagerAddress,
                                "buy",
                              ).then(() => {
                                setRefereshDetails(!refereshDetails);
                                setCustomPopupPosition("center");
                                setCustomPopupContent(null);
                                setShowCustomPopup(false);
                              });
                            }
                          } else {
                            setCustomPopupPosition("flex-end");
                            setCustomPopupContent(
                              <SuccessPopup
                                setShowPopup={props.setShowPopup}
                                setPopupContent={props.setPopupContent}
                                setPopupContentPosition={
                                  props.setPopupContentPosition
                                }
                                isCustom={true}
                                customTextHeader="Error while creating order"
                                customTextFooter="Buy order failed."
                                setFavouriteClicked={props.setFavouriteClicked}
                                isError={true}
                                setCustomPopupPosition={setCustomPopupPosition}
                                setCustomPopupContent={setCustomPopupContent}
                                setShowCustomPopup={setShowCustomPopup}
                              />,
                            );
                            setShowCustomPopup(true);

                            errorToast(
                              "unexpected Error!",
                              "Buy order failed. Try again later",
                            );
                            return;
                          }
                          props.setCustomLoading(false);
                        } else {
                          setCustomPopupPosition("center");
                          setCustomPopupContent(null);
                          setShowCustomPopup(false);
                          errorToast(
                            "Oops Something went wrong",
                            "Unexpected error. Try again later",
                          );
                          return;
                        }
                      });
                    }}
                  >
                    <p className="asset-info-popup-collateral-button-text">
                      {t("assetInfo.buyAsset")}
                    </p>
                  </button>
                ))}

            {userCustomerAccount?.cashAccountNumber !== "" &&
              tradeType === "sell" && (
                <button
                  style={{
                    marginTop: "50px",
                    marginBottom: "50px",
                    width: "100%",
                    background: "var(--Error-700, #bc1919)",
                  }}
                  className="asset-info-popup-collateral-button"
                >
                  <p className="asset-info-popup-collateral-button-text">
                    {t("assetInfo.sellAsset")}
                  </p>
                </button>
              )}
          </React.Fragment>
        )}

        {showSetCollateral && !showSelectBank && !showUnderlyingAsset && (
          <React.Fragment>
            {showSetCollateralType === "deposit" && (
              <button
                style={{ marginTop: "50px", marginBottom: "50px" }}
                onClick={async () => {
                  await authenticateKYCStatus(
                    chainId,
                    userAddress,
                    web3,
                    appKitModal,
                    props.setPopupContent,
                    props.setPopupContentPosition,
                    props.setShowPopup,
                    props.setCustomLoading,
                    props.setFavouriteClicked,
                    false,
                    setVerifiedWalletDetails,
                    verifiedWalletDetails,
                    props.generalDataProps,
                  ).then(async (res) => {
                    if (
                      res &&
                      signer &&
                      chainId > 0 &&
                      userAddress?.length > 0 &&
                      web3 &&
                      provider
                    ) {
                      if (Number(collateralAmount) <= 0) {
                        errorToast(
                          "Invalid amount",
                          "Please enter a valid amount",
                        );
                        return;
                      }
                      if (
                        Number(userBalances?.currency) <
                        Number(collateralAmount)
                      ) {
                        errorToast(
                          "Insufficient Balance",
                          "Top up your balance and try again later",
                        );
                        return;
                      }
                      props.setCustomLoading(true);
                      const collateralAmountFmt = ethers.utils.parseUnits(
                        collateralAmount?.toString(),
                        Number(props.productClicked?.currencyDecimals),
                      );
                      let paymentToken;

                      if (
                        verifiedWalletDetails &&
                        Object?.keys(verifiedWalletDetails)?.length > 0
                      ) {
                        const cashTokens = await getAllVerifiedCashBalances(
                          chainId,
                          web3,
                          userAddress,
                        );
                        if (!cashTokens || cashTokens?.length === 0) {
                          props.setCustomLoading(false);
                          errorToast(
                            "Unexpected Error",
                            "No valid Cash Token on this network. Change network and try again.",
                          );

                          return;
                        }
                        paymentToken = cashTokens[0];

                        if (Number(cashTokens[0]?.balance) === 0) {
                          props.setCustomLoading(false);
                          errorToast(
                            `Insufficient ${cashTokens[0]?.name} balance`,
                            `Top up ${cashTokens[0]?.name} to proceed.`,
                            <p
                              className="general-web-toast-success-link-text"
                              onClick={() => {
                                props.setPopupContentPosition("flex-end");
                                props.setPopupContent(
                                  <AddFunds
                                    setShowPopup={props.setShowPopup}
                                    setPopupContent={props.setPopupContent}
                                    setPopupContentPosition={
                                      props.setPopupContentPosition
                                    }
                                    customLoading={props.customLoading}
                                    setCustomLoading={props.setCustomLoading}
                                    generalDataProps={props.generalDataProps}
                                    addFundsAction="add-funds"
                                  />,
                                );
                                props.setShowPopup(true);
                              }}
                            >
                              Top Up
                            </p>,
                          );

                          return;
                        }
                      }
                      await offerCollateral(
                        chainId,
                        userAddress,
                        signer,
                        web3,
                        props.productClicked?.security,
                        props.productClicked?.currency,
                        collateralAmountFmt,
                        paymentToken,
                        provider,
                        custodyWalletDetails,
                      ).then((res) => {
                        props.setCustomLoading(false);
                        if (res) {
                          setCollateralAdded(
                            collateralAdded + collateralAmount,
                          );
                          setShowSetCollateral(false);
                        }
                      });
                    }
                  });
                  setPayWithBank(false);
                  setPayWithVerifiedWallet(false);
                }}
                className="asset-info-popup-collateral-button"
              >
                <p className="asset-info-popup-collateral-button-text">
                  {t("assetInfo.collateral")}
                </p>
              </button>
            )}
            {showSetCollateralType === "withdraw" && (
              <button
                style={{ marginTop: "50px", marginBottom: "50px" }}
                onClick={async () => {
                  await authenticateKYCStatus(
                    chainId,
                    userAddress,
                    web3,
                    appKitModal,
                    props.setPopupContent,
                    props.setPopupContentPosition,
                    props.setShowPopup,
                    props.setCustomLoading,
                    props.setFavouriteClicked,
                    false,
                    setVerifiedWalletDetails,
                    verifiedWalletDetails,
                    props.generalDataProps,
                  ).then(async (res) => {
                    if (
                      res &&
                      signer &&
                      chainId > 0 &&
                      userAddress?.length > 0 &&
                      web3 &&
                      provider &&
                      props?.withdrawableRef?.length > 0
                    ) {
                      if (Number(collateralAmount) <= 0) {
                        errorToast(
                          "Invalid amount",
                          "Please enter a valid amount",
                        );
                        return;
                      }
                      if (
                        Number(props?.totalWithdrawable) <
                        Number(collateralAmount)
                      ) {
                        errorToast(
                          "Insufficient Withdrawable Balance.",
                          `Withdrawable Balance for this order is: ${Number(props?.totalWithdrawable)?.toFixed(4)} `,
                        );
                        return;
                      }
                      props.setCustomLoading(true);
                      const collateralAmountFmt = ethers.utils.parseUnits(
                        collateralAmount?.toString(),
                        Number(props.productClicked?.currencyDecimals),
                      );
                      let paymentToken;

                      if (
                        verifiedWalletDetails &&
                        Object?.keys(verifiedWalletDetails)?.length > 0
                      ) {
                        const cashTokens = await getAllVerifiedCashBalances(
                          chainId,
                          web3,
                          userAddress,
                        );
                        if (!cashTokens || cashTokens?.length === 0) {
                          props.setCustomLoading(false);
                          errorToast(
                            "Unexpected Error",
                            "No valid Cash Token on this network. Change network and try again.",
                          );

                          return;
                        }
                        paymentToken = cashTokens[0];

                        if (Number(cashTokens[0]?.balance) === 0) {
                          props.setCustomLoading(false);
                          errorToast(
                            `Insufficient ${cashTokens[0]?.name} balance`,
                            `Top up ${cashTokens[0]?.name} to proceed.`,
                            <p
                              className="general-web-toast-success-link-text"
                              onClick={() => {
                                props.setPopupContentPosition("flex-end");
                                props.setPopupContent(
                                  <AddFunds
                                    setShowPopup={props.setShowPopup}
                                    setPopupContent={props.setPopupContent}
                                    setPopupContentPosition={
                                      props.setPopupContentPosition
                                    }
                                    customLoading={props.customLoading}
                                    setCustomLoading={props.setCustomLoading}
                                    generalDataProps={props.generalDataProps}
                                    addFundsAction="add-funds"
                                  />,
                                );
                                props.setShowPopup(true);
                              }}
                            >
                              Top Up
                            </p>,
                          );

                          return;
                        }
                      }
                      await withdrawCollateral(
                        chainId,
                        userAddress,
                        signer,
                        web3,
                        props?.withdrawableRef,
                        props.productClicked?.security,
                        props.productClicked?.currency,
                        collateralAmountFmt,
                        paymentToken,
                        provider,
                        custodyWalletDetails,
                      ).then((res) => {
                        props.setCustomLoading(false);
                        if (res) {
                          setCollateralAdded(
                            collateralAdded - collateralAmount,
                          );
                          setShowSetCollateral(false);
                        }
                      });
                    }
                  });
                  setPayWithBank(false);
                  setPayWithVerifiedWallet(false);
                }}
                className="asset-info-popup-collateral-button"
              >
                <p className="asset-info-popup-collateral-button-text">
                  Withdraw
                </p>
              </button>
            )}
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default AssetInfoPage;
